import * as Ve from "react";
import br, { useState as Xn, useEffect as Et } from "react";
import { Button as Qr, Typography as Ae, useTheme as cn, useMediaQuery as Xr, Box as ye, Link as et, FormControlLabel as eo, Checkbox as ro } from "@mui/material";
import to from "@emotion/styled";
import { ThemeContext as no, css as ln, keyframes as un } from "@emotion/react";
function oo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var sr = { exports: {} }, Ye = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var jr, wt;
function rt() {
  if (wt) return jr;
  wt = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, c = 0; c < 10; c++)
        s["_" + String.fromCharCode(c)] = c;
      var f = Object.getOwnPropertyNames(s).map(function(h) {
        return s[h];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        d[h] = h;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return jr = o() ? Object.assign : function(i, s) {
    for (var c, f = n(i), d, h = 1; h < arguments.length; h++) {
      c = Object(arguments[h]);
      for (var m in c)
        r.call(c, m) && (f[m] = c[m]);
      if (e) {
        d = e(c);
        for (var g = 0; g < d.length; g++)
          t.call(c, d[g]) && (f[d[g]] = c[d[g]]);
      }
    }
    return f;
  }, jr;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tt;
function io() {
  if (Tt) return Ye;
  Tt = 1, rt();
  var e = br, r = 60103;
  if (Ye.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var t = Symbol.for;
    r = t("react.element"), Ye.Fragment = t("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(c, f, d) {
    var h, m = {}, g = null, C = null;
    d !== void 0 && (g = "" + d), f.key !== void 0 && (g = "" + f.key), f.ref !== void 0 && (C = f.ref);
    for (h in f) o.call(f, h) && !i.hasOwnProperty(h) && (m[h] = f[h]);
    if (c && c.defaultProps) for (h in f = c.defaultProps, f) m[h] === void 0 && (m[h] = f[h]);
    return { $$typeof: r, type: c, key: g, ref: C, props: m, _owner: n.current };
  }
  return Ye.jsx = s, Ye.jsxs = s, Ye;
}
var Mr = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _t;
function ao() {
  return _t || (_t = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var r = br, t = rt(), n = 60103, o = 60106;
      e.Fragment = 60107;
      var i = 60108, s = 60114, c = 60109, f = 60110, d = 60112, h = 60113, m = 60120, g = 60115, C = 60116, v = 60121, u = 60122, R = 60117, k = 60129, F = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var E = Symbol.for;
        n = E("react.element"), o = E("react.portal"), e.Fragment = E("react.fragment"), i = E("react.strict_mode"), s = E("react.profiler"), c = E("react.provider"), f = E("react.context"), d = E("react.forward_ref"), h = E("react.suspense"), m = E("react.suspense_list"), g = E("react.memo"), C = E("react.lazy"), v = E("react.block"), u = E("react.server.block"), R = E("react.fundamental"), E("react.scope"), E("react.opaque.id"), k = E("react.debug_trace_mode"), E("react.offscreen"), F = E("react.legacy_hidden");
      }
      var T = typeof Symbol == "function" && Symbol.iterator, y = "@@iterator";
      function G(l) {
        if (l === null || typeof l != "object")
          return null;
        var S = T && l[T] || l[y];
        return typeof S == "function" ? S : null;
      }
      var ne = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function Z(l) {
        {
          for (var S = arguments.length, O = new Array(S > 1 ? S - 1 : 0), P = 1; P < S; P++)
            O[P - 1] = arguments[P];
          me("error", l, O);
        }
      }
      function me(l, S, O) {
        {
          var P = ne.ReactDebugCurrentFrame, oe = P.getStackAddendum();
          oe !== "" && (S += "%s", O = O.concat([oe]));
          var ee = O.map(function(z) {
            return "" + z;
          });
          ee.unshift("Warning: " + S), Function.prototype.apply.call(console[l], console, ee);
        }
      }
      var a = !1;
      function $(l) {
        return !!(typeof l == "string" || typeof l == "function" || l === e.Fragment || l === s || l === k || l === i || l === h || l === m || l === F || a || typeof l == "object" && l !== null && (l.$$typeof === C || l.$$typeof === g || l.$$typeof === c || l.$$typeof === f || l.$$typeof === d || l.$$typeof === R || l.$$typeof === v || l[0] === u));
      }
      function I(l, S, O) {
        var P = S.displayName || S.name || "";
        return l.displayName || (P !== "" ? O + "(" + P + ")" : O);
      }
      function U(l) {
        return l.displayName || "Context";
      }
      function K(l) {
        if (l == null)
          return null;
        if (typeof l.tag == "number" && Z("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof l == "function")
          return l.displayName || l.name || null;
        if (typeof l == "string")
          return l;
        switch (l) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case s:
            return "Profiler";
          case i:
            return "StrictMode";
          case h:
            return "Suspense";
          case m:
            return "SuspenseList";
        }
        if (typeof l == "object")
          switch (l.$$typeof) {
            case f:
              var S = l;
              return U(S) + ".Consumer";
            case c:
              var O = l;
              return U(O._context) + ".Provider";
            case d:
              return I(l, l.render, "ForwardRef");
            case g:
              return K(l.type);
            case v:
              return K(l._render);
            case C: {
              var P = l, oe = P._payload, ee = P._init;
              try {
                return K(ee(oe));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var fe = 0, pe, be, we, Le, x, _, B;
      function D() {
      }
      D.__reactDisabledLog = !0;
      function j() {
        {
          if (fe === 0) {
            pe = console.log, be = console.info, we = console.warn, Le = console.error, x = console.group, _ = console.groupCollapsed, B = console.groupEnd;
            var l = {
              configurable: !0,
              enumerable: !0,
              value: D,
              writable: !0
            };
            Object.defineProperties(console, {
              info: l,
              log: l,
              warn: l,
              error: l,
              group: l,
              groupCollapsed: l,
              groupEnd: l
            });
          }
          fe++;
        }
      }
      function q() {
        {
          if (fe--, fe === 0) {
            var l = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: t({}, l, {
                value: pe
              }),
              info: t({}, l, {
                value: be
              }),
              warn: t({}, l, {
                value: we
              }),
              error: t({}, l, {
                value: Le
              }),
              group: t({}, l, {
                value: x
              }),
              groupCollapsed: t({}, l, {
                value: _
              }),
              groupEnd: t({}, l, {
                value: B
              })
            });
          }
          fe < 0 && Z("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var M = ne.ReactCurrentDispatcher, N;
      function V(l, S, O) {
        {
          if (N === void 0)
            try {
              throw Error();
            } catch (oe) {
              var P = oe.stack.trim().match(/\n( *(at )?)/);
              N = P && P[1] || "";
            }
          return `
` + N + l;
        }
      }
      var Y = !1, L;
      {
        var he = typeof WeakMap == "function" ? WeakMap : Map;
        L = new he();
      }
      function w(l, S) {
        if (!l || Y)
          return "";
        {
          var O = L.get(l);
          if (O !== void 0)
            return O;
        }
        var P;
        Y = !0;
        var oe = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var ee;
        ee = M.current, M.current = null, j();
        try {
          if (S) {
            var z = function() {
              throw Error();
            };
            if (Object.defineProperty(z.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(z, []);
              } catch (Oe) {
                P = Oe;
              }
              Reflect.construct(l, [], z);
            } else {
              try {
                z.call();
              } catch (Oe) {
                P = Oe;
              }
              l.call(z.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Oe) {
              P = Oe;
            }
            l();
          }
        } catch (Oe) {
          if (Oe && P && typeof Oe.stack == "string") {
            for (var W = Oe.stack.split(`
`), ge = P.stack.split(`
`), ce = W.length - 1, de = ge.length - 1; ce >= 1 && de >= 0 && W[ce] !== ge[de]; )
              de--;
            for (; ce >= 1 && de >= 0; ce--, de--)
              if (W[ce] !== ge[de]) {
                if (ce !== 1 || de !== 1)
                  do
                    if (ce--, de--, de < 0 || W[ce] !== ge[de]) {
                      var _e = `
` + W[ce].replace(" at new ", " at ");
                      return typeof l == "function" && L.set(l, _e), _e;
                    }
                  while (ce >= 1 && de >= 0);
                break;
              }
          }
        } finally {
          Y = !1, M.current = ee, q(), Error.prepareStackTrace = oe;
        }
        var Ue = l ? l.displayName || l.name : "", Ct = Ue ? V(Ue) : "";
        return typeof l == "function" && L.set(l, Ct), Ct;
      }
      function ve(l, S, O) {
        return w(l, !1);
      }
      function We(l) {
        var S = l.prototype;
        return !!(S && S.isReactComponent);
      }
      function Be(l, S, O) {
        if (l == null)
          return "";
        if (typeof l == "function")
          return w(l, We(l));
        if (typeof l == "string")
          return V(l);
        switch (l) {
          case h:
            return V("Suspense");
          case m:
            return V("SuspenseList");
        }
        if (typeof l == "object")
          switch (l.$$typeof) {
            case d:
              return ve(l.render);
            case g:
              return Be(l.type, S, O);
            case v:
              return ve(l._render);
            case C: {
              var P = l, oe = P._payload, ee = P._init;
              try {
                return Be(ee(oe), S, O);
              } catch {
              }
            }
          }
        return "";
      }
      var ft = {}, dt = ne.ReactDebugCurrentFrame;
      function ar(l) {
        if (l) {
          var S = l._owner, O = Be(l.type, l._source, S ? S.type : null);
          dt.setExtraStackFrame(O);
        } else
          dt.setExtraStackFrame(null);
      }
      function Nn(l, S, O, P, oe) {
        {
          var ee = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var z in l)
            if (ee(l, z)) {
              var W = void 0;
              try {
                if (typeof l[z] != "function") {
                  var ge = Error((P || "React class") + ": " + O + " type `" + z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[z] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ge.name = "Invariant Violation", ge;
                }
                W = l[z](S, z, P, O, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ce) {
                W = ce;
              }
              W && !(W instanceof Error) && (ar(oe), Z("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", P || "React class", O, z, typeof W), ar(null)), W instanceof Error && !(W.message in ft) && (ft[W.message] = !0, ar(oe), Z("Failed %s type: %s", O, W.message), ar(null));
            }
        }
      }
      var pt = ne.ReactCurrentOwner, kr = Object.prototype.hasOwnProperty, Dn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, mt, ht;
      function Bn(l) {
        if (kr.call(l, "ref")) {
          var S = Object.getOwnPropertyDescriptor(l, "ref").get;
          if (S && S.isReactWarning)
            return !1;
        }
        return l.ref !== void 0;
      }
      function Fn(l) {
        if (kr.call(l, "key")) {
          var S = Object.getOwnPropertyDescriptor(l, "key").get;
          if (S && S.isReactWarning)
            return !1;
        }
        return l.key !== void 0;
      }
      function Vn(l, S) {
        typeof l.ref == "string" && pt.current;
      }
      function Ln(l, S) {
        {
          var O = function() {
            mt || (mt = !0, Z("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
          };
          O.isReactWarning = !0, Object.defineProperty(l, "key", {
            get: O,
            configurable: !0
          });
        }
      }
      function Wn(l, S) {
        {
          var O = function() {
            ht || (ht = !0, Z("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
          };
          O.isReactWarning = !0, Object.defineProperty(l, "ref", {
            get: O,
            configurable: !0
          });
        }
      }
      var qn = function(l, S, O, P, oe, ee, z) {
        var W = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: l,
          key: S,
          ref: O,
          props: z,
          // Record the component responsible for creating this element.
          _owner: ee
        };
        return W._store = {}, Object.defineProperty(W._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(W, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: P
        }), Object.defineProperty(W, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: oe
        }), Object.freeze && (Object.freeze(W.props), Object.freeze(W)), W;
      };
      function Un(l, S, O, P, oe) {
        {
          var ee, z = {}, W = null, ge = null;
          O !== void 0 && (W = "" + O), Fn(S) && (W = "" + S.key), Bn(S) && (ge = S.ref, Vn(S, oe));
          for (ee in S)
            kr.call(S, ee) && !Dn.hasOwnProperty(ee) && (z[ee] = S[ee]);
          if (l && l.defaultProps) {
            var ce = l.defaultProps;
            for (ee in ce)
              z[ee] === void 0 && (z[ee] = ce[ee]);
          }
          if (W || ge) {
            var de = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
            W && Ln(z, de), ge && Wn(z, de);
          }
          return qn(l, W, ge, oe, P, pt.current, z);
        }
      }
      var Ar = ne.ReactCurrentOwner, gt = ne.ReactDebugCurrentFrame;
      function qe(l) {
        if (l) {
          var S = l._owner, O = Be(l.type, l._source, S ? S.type : null);
          gt.setExtraStackFrame(O);
        } else
          gt.setExtraStackFrame(null);
      }
      var Pr;
      Pr = !1;
      function Ir(l) {
        return typeof l == "object" && l !== null && l.$$typeof === n;
      }
      function yt() {
        {
          if (Ar.current) {
            var l = K(Ar.current.type);
            if (l)
              return `

Check the render method of \`` + l + "`.";
          }
          return "";
        }
      }
      function Yn(l) {
        return "";
      }
      var bt = {};
      function zn(l) {
        {
          var S = yt();
          if (!S) {
            var O = typeof l == "string" ? l : l.displayName || l.name;
            O && (S = `

Check the top-level render call using <` + O + ">.");
          }
          return S;
        }
      }
      function vt(l, S) {
        {
          if (!l._store || l._store.validated || l.key != null)
            return;
          l._store.validated = !0;
          var O = zn(S);
          if (bt[O])
            return;
          bt[O] = !0;
          var P = "";
          l && l._owner && l._owner !== Ar.current && (P = " It was passed a child from " + K(l._owner.type) + "."), qe(l), Z('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', O, P), qe(null);
        }
      }
      function xt(l, S) {
        {
          if (typeof l != "object")
            return;
          if (Array.isArray(l))
            for (var O = 0; O < l.length; O++) {
              var P = l[O];
              Ir(P) && vt(P, S);
            }
          else if (Ir(l))
            l._store && (l._store.validated = !0);
          else if (l) {
            var oe = G(l);
            if (typeof oe == "function" && oe !== l.entries)
              for (var ee = oe.call(l), z; !(z = ee.next()).done; )
                Ir(z.value) && vt(z.value, S);
          }
        }
      }
      function Gn(l) {
        {
          var S = l.type;
          if (S == null || typeof S == "string")
            return;
          var O;
          if (typeof S == "function")
            O = S.propTypes;
          else if (typeof S == "object" && (S.$$typeof === d || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          S.$$typeof === g))
            O = S.propTypes;
          else
            return;
          if (O) {
            var P = K(S);
            Nn(O, l.props, "prop", P, l);
          } else if (S.PropTypes !== void 0 && !Pr) {
            Pr = !0;
            var oe = K(S);
            Z("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", oe || "Unknown");
          }
          typeof S.getDefaultProps == "function" && !S.getDefaultProps.isReactClassApproved && Z("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Zn(l) {
        {
          for (var S = Object.keys(l.props), O = 0; O < S.length; O++) {
            var P = S[O];
            if (P !== "children" && P !== "key") {
              qe(l), Z("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", P), qe(null);
              break;
            }
          }
          l.ref !== null && (qe(l), Z("Invalid attribute `ref` supplied to `React.Fragment`."), qe(null));
        }
      }
      function St(l, S, O, P, oe, ee) {
        {
          var z = $(l);
          if (!z) {
            var W = "";
            (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (W += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var ge = Yn();
            ge ? W += ge : W += yt();
            var ce;
            l === null ? ce = "null" : Array.isArray(l) ? ce = "array" : l !== void 0 && l.$$typeof === n ? (ce = "<" + (K(l.type) || "Unknown") + " />", W = " Did you accidentally export a JSX literal instead of a component?") : ce = typeof l, Z("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ce, W);
          }
          var de = Un(l, S, O, oe, ee);
          if (de == null)
            return de;
          if (z) {
            var _e = S.children;
            if (_e !== void 0)
              if (P)
                if (Array.isArray(_e)) {
                  for (var Ue = 0; Ue < _e.length; Ue++)
                    xt(_e[Ue], l);
                  Object.freeze && Object.freeze(_e);
                } else
                  Z("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                xt(_e, l);
          }
          return l === e.Fragment ? Zn(de) : Gn(de), de;
        }
      }
      function Kn(l, S, O) {
        return St(l, S, O, !0);
      }
      function Hn(l, S, O) {
        return St(l, S, O, !1);
      }
      var Jn = Hn, Qn = Kn;
      e.jsx = Jn, e.jsxs = Qn;
    }();
  }(Mr)), Mr;
}
var Ot;
function so() {
  return Ot || (Ot = 1, process.env.NODE_ENV === "production" ? sr.exports = io() : sr.exports = ao()), sr.exports;
}
var A = so(), cr = { exports: {} }, lr = { exports: {} }, H = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rt;
function co() {
  if (Rt) return H;
  Rt = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, u = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
  function E(y) {
    if (typeof y == "object" && y !== null) {
      var G = y.$$typeof;
      switch (G) {
        case r:
          switch (y = y.type, y) {
            case f:
            case d:
            case n:
            case i:
            case o:
            case m:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case c:
                case h:
                case v:
                case C:
                case s:
                  return y;
                default:
                  return G;
              }
          }
        case t:
          return G;
      }
    }
  }
  function T(y) {
    return E(y) === d;
  }
  return H.AsyncMode = f, H.ConcurrentMode = d, H.ContextConsumer = c, H.ContextProvider = s, H.Element = r, H.ForwardRef = h, H.Fragment = n, H.Lazy = v, H.Memo = C, H.Portal = t, H.Profiler = i, H.StrictMode = o, H.Suspense = m, H.isAsyncMode = function(y) {
    return T(y) || E(y) === f;
  }, H.isConcurrentMode = T, H.isContextConsumer = function(y) {
    return E(y) === c;
  }, H.isContextProvider = function(y) {
    return E(y) === s;
  }, H.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === r;
  }, H.isForwardRef = function(y) {
    return E(y) === h;
  }, H.isFragment = function(y) {
    return E(y) === n;
  }, H.isLazy = function(y) {
    return E(y) === v;
  }, H.isMemo = function(y) {
    return E(y) === C;
  }, H.isPortal = function(y) {
    return E(y) === t;
  }, H.isProfiler = function(y) {
    return E(y) === i;
  }, H.isStrictMode = function(y) {
    return E(y) === o;
  }, H.isSuspense = function(y) {
    return E(y) === m;
  }, H.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === d || y === i || y === o || y === m || y === g || typeof y == "object" && y !== null && (y.$$typeof === v || y.$$typeof === C || y.$$typeof === s || y.$$typeof === c || y.$$typeof === h || y.$$typeof === R || y.$$typeof === k || y.$$typeof === F || y.$$typeof === u);
  }, H.typeOf = E, H;
}
var J = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $t;
function lo() {
  return $t || ($t = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, u = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
    function E(w) {
      return typeof w == "string" || typeof w == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      w === n || w === d || w === i || w === o || w === m || w === g || typeof w == "object" && w !== null && (w.$$typeof === v || w.$$typeof === C || w.$$typeof === s || w.$$typeof === c || w.$$typeof === h || w.$$typeof === R || w.$$typeof === k || w.$$typeof === F || w.$$typeof === u);
    }
    function T(w) {
      if (typeof w == "object" && w !== null) {
        var ve = w.$$typeof;
        switch (ve) {
          case r:
            var We = w.type;
            switch (We) {
              case f:
              case d:
              case n:
              case i:
              case o:
              case m:
                return We;
              default:
                var Be = We && We.$$typeof;
                switch (Be) {
                  case c:
                  case h:
                  case v:
                  case C:
                  case s:
                    return Be;
                  default:
                    return ve;
                }
            }
          case t:
            return ve;
        }
      }
    }
    var y = f, G = d, ne = c, Z = s, me = r, a = h, $ = n, I = v, U = C, K = t, fe = i, pe = o, be = m, we = !1;
    function Le(w) {
      return we || (we = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), x(w) || T(w) === f;
    }
    function x(w) {
      return T(w) === d;
    }
    function _(w) {
      return T(w) === c;
    }
    function B(w) {
      return T(w) === s;
    }
    function D(w) {
      return typeof w == "object" && w !== null && w.$$typeof === r;
    }
    function j(w) {
      return T(w) === h;
    }
    function q(w) {
      return T(w) === n;
    }
    function M(w) {
      return T(w) === v;
    }
    function N(w) {
      return T(w) === C;
    }
    function V(w) {
      return T(w) === t;
    }
    function Y(w) {
      return T(w) === i;
    }
    function L(w) {
      return T(w) === o;
    }
    function he(w) {
      return T(w) === m;
    }
    J.AsyncMode = y, J.ConcurrentMode = G, J.ContextConsumer = ne, J.ContextProvider = Z, J.Element = me, J.ForwardRef = a, J.Fragment = $, J.Lazy = I, J.Memo = U, J.Portal = K, J.Profiler = fe, J.StrictMode = pe, J.Suspense = be, J.isAsyncMode = Le, J.isConcurrentMode = x, J.isContextConsumer = _, J.isContextProvider = B, J.isElement = D, J.isForwardRef = j, J.isFragment = q, J.isLazy = M, J.isMemo = N, J.isPortal = V, J.isProfiler = Y, J.isStrictMode = L, J.isSuspense = he, J.isValidElementType = E, J.typeOf = T;
  }()), J;
}
var kt;
function fn() {
  return kt || (kt = 1, process.env.NODE_ENV === "production" ? lr.exports = co() : lr.exports = lo()), lr.exports;
}
var Nr, At;
function tt() {
  if (At) return Nr;
  At = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Nr = e, Nr;
}
var Dr, Pt;
function dn() {
  return Pt || (Pt = 1, Dr = Function.call.bind(Object.prototype.hasOwnProperty)), Dr;
}
var Br, It;
function uo() {
  if (It) return Br;
  It = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = /* @__PURE__ */ tt(), t = {}, n = /* @__PURE__ */ dn();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, c, f, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in i)
        if (n(i, h)) {
          var m;
          try {
            if (typeof i[h] != "function") {
              var g = Error(
                (f || "React class") + ": " + c + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            m = i[h](s, h, f, c, null, r);
          } catch (v) {
            m = v;
          }
          if (m && !(m instanceof Error) && e(
            (f || "React class") + ": type specification of " + c + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in t)) {
            t[m.message] = !0;
            var C = d ? d() : "";
            e(
              "Failed " + c + " type: " + m.message + (C ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Br = o, Br;
}
var Fr, jt;
function fo() {
  if (jt) return Fr;
  jt = 1;
  var e = fn(), r = rt(), t = /* @__PURE__ */ tt(), n = /* @__PURE__ */ dn(), o = /* @__PURE__ */ uo(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(c) {
    var f = "Warning: " + c;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Fr = function(c, f) {
    var d = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function m(x) {
      var _ = x && (d && x[d] || x[h]);
      if (typeof _ == "function")
        return _;
    }
    var g = "<<anonymous>>", C = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: F(),
      arrayOf: E,
      element: T(),
      elementType: y(),
      instanceOf: G,
      node: a(),
      objectOf: Z,
      oneOf: ne,
      oneOfType: me,
      shape: I,
      exact: U
    };
    function v(x, _) {
      return x === _ ? x !== 0 || 1 / x === 1 / _ : x !== x && _ !== _;
    }
    function u(x, _) {
      this.message = x, this.data = _ && typeof _ == "object" ? _ : {}, this.stack = "";
    }
    u.prototype = Error.prototype;
    function R(x) {
      if (process.env.NODE_ENV !== "production")
        var _ = {}, B = 0;
      function D(q, M, N, V, Y, L, he) {
        if (V = V || g, L = L || N, he !== t) {
          if (f) {
            var w = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw w.name = "Invariant Violation", w;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ve = V + ":" + N;
            !_[ve] && // Avoid spamming the console because they are often not actionable except for lib authors
            B < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + L + "` prop on `" + V + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), _[ve] = !0, B++);
          }
        }
        return M[N] == null ? q ? M[N] === null ? new u("The " + Y + " `" + L + "` is marked as required " + ("in `" + V + "`, but its value is `null`.")) : new u("The " + Y + " `" + L + "` is marked as required in " + ("`" + V + "`, but its value is `undefined`.")) : null : x(M, N, V, Y, L);
      }
      var j = D.bind(null, !1);
      return j.isRequired = D.bind(null, !0), j;
    }
    function k(x) {
      function _(B, D, j, q, M, N) {
        var V = B[D], Y = pe(V);
        if (Y !== x) {
          var L = be(V);
          return new u(
            "Invalid " + q + " `" + M + "` of type " + ("`" + L + "` supplied to `" + j + "`, expected ") + ("`" + x + "`."),
            { expectedType: x }
          );
        }
        return null;
      }
      return R(_);
    }
    function F() {
      return R(s);
    }
    function E(x) {
      function _(B, D, j, q, M) {
        if (typeof x != "function")
          return new u("Property `" + M + "` of component `" + j + "` has invalid PropType notation inside arrayOf.");
        var N = B[D];
        if (!Array.isArray(N)) {
          var V = pe(N);
          return new u("Invalid " + q + " `" + M + "` of type " + ("`" + V + "` supplied to `" + j + "`, expected an array."));
        }
        for (var Y = 0; Y < N.length; Y++) {
          var L = x(N, Y, j, q, M + "[" + Y + "]", t);
          if (L instanceof Error)
            return L;
        }
        return null;
      }
      return R(_);
    }
    function T() {
      function x(_, B, D, j, q) {
        var M = _[B];
        if (!c(M)) {
          var N = pe(M);
          return new u("Invalid " + j + " `" + q + "` of type " + ("`" + N + "` supplied to `" + D + "`, expected a single ReactElement."));
        }
        return null;
      }
      return R(x);
    }
    function y() {
      function x(_, B, D, j, q) {
        var M = _[B];
        if (!e.isValidElementType(M)) {
          var N = pe(M);
          return new u("Invalid " + j + " `" + q + "` of type " + ("`" + N + "` supplied to `" + D + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return R(x);
    }
    function G(x) {
      function _(B, D, j, q, M) {
        if (!(B[D] instanceof x)) {
          var N = x.name || g, V = Le(B[D]);
          return new u("Invalid " + q + " `" + M + "` of type " + ("`" + V + "` supplied to `" + j + "`, expected ") + ("instance of `" + N + "`."));
        }
        return null;
      }
      return R(_);
    }
    function ne(x) {
      if (!Array.isArray(x))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function _(B, D, j, q, M) {
        for (var N = B[D], V = 0; V < x.length; V++)
          if (v(N, x[V]))
            return null;
        var Y = JSON.stringify(x, function(he, w) {
          var ve = be(w);
          return ve === "symbol" ? String(w) : w;
        });
        return new u("Invalid " + q + " `" + M + "` of value `" + String(N) + "` " + ("supplied to `" + j + "`, expected one of " + Y + "."));
      }
      return R(_);
    }
    function Z(x) {
      function _(B, D, j, q, M) {
        if (typeof x != "function")
          return new u("Property `" + M + "` of component `" + j + "` has invalid PropType notation inside objectOf.");
        var N = B[D], V = pe(N);
        if (V !== "object")
          return new u("Invalid " + q + " `" + M + "` of type " + ("`" + V + "` supplied to `" + j + "`, expected an object."));
        for (var Y in N)
          if (n(N, Y)) {
            var L = x(N, Y, j, q, M + "." + Y, t);
            if (L instanceof Error)
              return L;
          }
        return null;
      }
      return R(_);
    }
    function me(x) {
      if (!Array.isArray(x))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var _ = 0; _ < x.length; _++) {
        var B = x[_];
        if (typeof B != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + we(B) + " at index " + _ + "."
          ), s;
      }
      function D(j, q, M, N, V) {
        for (var Y = [], L = 0; L < x.length; L++) {
          var he = x[L], w = he(j, q, M, N, V, t);
          if (w == null)
            return null;
          w.data && n(w.data, "expectedType") && Y.push(w.data.expectedType);
        }
        var ve = Y.length > 0 ? ", expected one of type [" + Y.join(", ") + "]" : "";
        return new u("Invalid " + N + " `" + V + "` supplied to " + ("`" + M + "`" + ve + "."));
      }
      return R(D);
    }
    function a() {
      function x(_, B, D, j, q) {
        return K(_[B]) ? null : new u("Invalid " + j + " `" + q + "` supplied to " + ("`" + D + "`, expected a ReactNode."));
      }
      return R(x);
    }
    function $(x, _, B, D, j) {
      return new u(
        (x || "React class") + ": " + _ + " type `" + B + "." + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + j + "`."
      );
    }
    function I(x) {
      function _(B, D, j, q, M) {
        var N = B[D], V = pe(N);
        if (V !== "object")
          return new u("Invalid " + q + " `" + M + "` of type `" + V + "` " + ("supplied to `" + j + "`, expected `object`."));
        for (var Y in x) {
          var L = x[Y];
          if (typeof L != "function")
            return $(j, q, M, Y, be(L));
          var he = L(N, Y, j, q, M + "." + Y, t);
          if (he)
            return he;
        }
        return null;
      }
      return R(_);
    }
    function U(x) {
      function _(B, D, j, q, M) {
        var N = B[D], V = pe(N);
        if (V !== "object")
          return new u("Invalid " + q + " `" + M + "` of type `" + V + "` " + ("supplied to `" + j + "`, expected `object`."));
        var Y = r({}, B[D], x);
        for (var L in Y) {
          var he = x[L];
          if (n(x, L) && typeof he != "function")
            return $(j, q, M, L, be(he));
          if (!he)
            return new u(
              "Invalid " + q + " `" + M + "` key `" + L + "` supplied to `" + j + "`.\nBad object: " + JSON.stringify(B[D], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(x), null, "  ")
            );
          var w = he(N, L, j, q, M + "." + L, t);
          if (w)
            return w;
        }
        return null;
      }
      return R(_);
    }
    function K(x) {
      switch (typeof x) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !x;
        case "object":
          if (Array.isArray(x))
            return x.every(K);
          if (x === null || c(x))
            return !0;
          var _ = m(x);
          if (_) {
            var B = _.call(x), D;
            if (_ !== x.entries) {
              for (; !(D = B.next()).done; )
                if (!K(D.value))
                  return !1;
            } else
              for (; !(D = B.next()).done; ) {
                var j = D.value;
                if (j && !K(j[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function fe(x, _) {
      return x === "symbol" ? !0 : _ ? _["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && _ instanceof Symbol : !1;
    }
    function pe(x) {
      var _ = typeof x;
      return Array.isArray(x) ? "array" : x instanceof RegExp ? "object" : fe(_, x) ? "symbol" : _;
    }
    function be(x) {
      if (typeof x > "u" || x === null)
        return "" + x;
      var _ = pe(x);
      if (_ === "object") {
        if (x instanceof Date)
          return "date";
        if (x instanceof RegExp)
          return "regexp";
      }
      return _;
    }
    function we(x) {
      var _ = be(x);
      switch (_) {
        case "array":
        case "object":
          return "an " + _;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + _;
        default:
          return _;
      }
    }
    function Le(x) {
      return !x.constructor || !x.constructor.name ? g : x.constructor.name;
    }
    return C.checkPropTypes = o, C.resetWarningCache = o.resetWarningCache, C.PropTypes = C, C;
  }, Fr;
}
var Vr, Mt;
function po() {
  if (Mt) return Vr;
  Mt = 1;
  var e = /* @__PURE__ */ tt();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, Vr = function() {
    function n(s, c, f, d, h, m) {
      if (m !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return i.PropTypes = i, i;
  }, Vr;
}
var Nt;
function mo() {
  if (Nt) return cr.exports;
  if (Nt = 1, process.env.NODE_ENV !== "production") {
    var e = fn(), r = !0;
    cr.exports = /* @__PURE__ */ fo()(e.isElement, r);
  } else
    cr.exports = /* @__PURE__ */ po()();
  return cr.exports;
}
var ho = /* @__PURE__ */ mo();
const b = /* @__PURE__ */ oo(ho), go = ({ label: e, onClick: r }) => /* @__PURE__ */ A.jsx("button", { onClick: r, children: e });
go.propTypes = {
  label: b.string.isRequired,
  onClick: b.func
};
function Me(e, ...r) {
  const t = new URL(`https://mui.com/production-error/?code=${e}`);
  return r.forEach((n) => t.searchParams.append("args[]", n)), `Minified MUI error #${e}; visit ${t} for the full message.`;
}
const pn = "$$material";
function yo(e) {
  for (var r = 0, t, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var bo = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function vo(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var xo = /[A-Z]|^ms/g, So = /_EMO_([^_]+?)_([^]*?)_EMO_/g, mn = function(r) {
  return r.charCodeAt(1) === 45;
}, Dt = function(r) {
  return r != null && typeof r != "boolean";
}, Lr = /* @__PURE__ */ vo(function(e) {
  return mn(e) ? e : e.replace(xo, "-$&").toLowerCase();
}), Bt = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(So, function(n, o, i) {
          return je = {
            name: o,
            styles: i,
            next: je
          }, o;
        });
  }
  return bo[r] !== 1 && !mn(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function hr(e, r, t) {
  if (t == null)
    return "";
  var n = t;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      var o = t;
      if (o.anim === 1)
        return je = {
          name: o.name,
          styles: o.styles,
          next: je
        }, o.name;
      var i = t;
      if (i.styles !== void 0) {
        var s = i.next;
        if (s !== void 0)
          for (; s !== void 0; )
            je = {
              name: s.name,
              styles: s.styles,
              next: je
            }, s = s.next;
        var c = i.styles + ";";
        return c;
      }
      return Co(e, r, t);
    }
  }
  var f = t;
  return f;
}
function Co(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var o = 0; o < t.length; o++)
      n += hr(e, r, t[o]) + ";";
  else
    for (var i in t) {
      var s = t[i];
      if (typeof s != "object") {
        var c = s;
        Dt(c) && (n += Lr(i) + ":" + Bt(i, c) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && r == null)
        for (var f = 0; f < s.length; f++)
          Dt(s[f]) && (n += Lr(i) + ":" + Bt(i, s[f]) + ";");
      else {
        var d = hr(e, r, s);
        switch (i) {
          case "animation":
          case "animationName": {
            n += Lr(i) + ":" + d + ";";
            break;
          }
          default:
            n += i + "{" + d + "}";
        }
      }
    }
  return n;
}
var Ft = /label:\s*([^\s;{]+)\s*(;|$)/g, je;
function Eo(e, r, t) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, o = "";
  je = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    n = !1, o += hr(t, r, i);
  else {
    var s = i;
    o += s[0];
  }
  for (var c = 1; c < e.length; c++)
    if (o += hr(t, r, e[c]), n) {
      var f = i;
      o += f[c];
    }
  Ft.lastIndex = 0;
  for (var d = "", h; (h = Ft.exec(o)) !== null; )
    d += "-" + h[1];
  var m = yo(o) + d;
  return {
    name: m,
    styles: o,
    next: je
  };
}
/**
 * @mui/styled-engine v6.4.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function wo(e, r) {
  const t = to(e, r);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), t(...n);
  } : t;
}
function To(e, r) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = r(e.__emotion_styles));
}
const Vt = [];
function Lt(e) {
  return Vt[0] = e, Eo(Vt);
}
var ur = { exports: {} }, Q = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wt;
function _o() {
  if (Wt) return Q;
  Wt = 1;
  var e = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), g = Symbol.for("react.view_transition"), C = Symbol.for("react.client.reference");
  function v(u) {
    if (typeof u == "object" && u !== null) {
      var R = u.$$typeof;
      switch (R) {
        case e:
          switch (u = u.type, u) {
            case t:
            case o:
            case n:
            case f:
            case d:
            case g:
              return u;
            default:
              switch (u = u && u.$$typeof, u) {
                case s:
                case c:
                case m:
                case h:
                  return u;
                case i:
                  return u;
                default:
                  return R;
              }
          }
        case r:
          return R;
      }
    }
  }
  return Q.ContextConsumer = i, Q.ContextProvider = s, Q.Element = e, Q.ForwardRef = c, Q.Fragment = t, Q.Lazy = m, Q.Memo = h, Q.Portal = r, Q.Profiler = o, Q.StrictMode = n, Q.Suspense = f, Q.SuspenseList = d, Q.isContextConsumer = function(u) {
    return v(u) === i;
  }, Q.isContextProvider = function(u) {
    return v(u) === s;
  }, Q.isElement = function(u) {
    return typeof u == "object" && u !== null && u.$$typeof === e;
  }, Q.isForwardRef = function(u) {
    return v(u) === c;
  }, Q.isFragment = function(u) {
    return v(u) === t;
  }, Q.isLazy = function(u) {
    return v(u) === m;
  }, Q.isMemo = function(u) {
    return v(u) === h;
  }, Q.isPortal = function(u) {
    return v(u) === r;
  }, Q.isProfiler = function(u) {
    return v(u) === o;
  }, Q.isStrictMode = function(u) {
    return v(u) === n;
  }, Q.isSuspense = function(u) {
    return v(u) === f;
  }, Q.isSuspenseList = function(u) {
    return v(u) === d;
  }, Q.isValidElementType = function(u) {
    return typeof u == "string" || typeof u == "function" || u === t || u === o || u === n || u === f || u === d || typeof u == "object" && u !== null && (u.$$typeof === m || u.$$typeof === h || u.$$typeof === s || u.$$typeof === i || u.$$typeof === c || u.$$typeof === C || u.getModuleId !== void 0);
  }, Q.typeOf = v, Q;
}
var X = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qt;
function Oo() {
  return qt || (qt = 1, process.env.NODE_ENV !== "production" && function() {
    function e(u) {
      if (typeof u == "object" && u !== null) {
        var R = u.$$typeof;
        switch (R) {
          case r:
            switch (u = u.type, u) {
              case n:
              case i:
              case o:
              case d:
              case h:
              case C:
                return u;
              default:
                switch (u = u && u.$$typeof, u) {
                  case c:
                  case f:
                  case g:
                  case m:
                    return u;
                  case s:
                    return u;
                  default:
                    return R;
                }
            }
          case t:
            return R;
        }
      }
    }
    var r = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), c = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), C = Symbol.for("react.view_transition"), v = Symbol.for("react.client.reference");
    X.ContextConsumer = s, X.ContextProvider = c, X.Element = r, X.ForwardRef = f, X.Fragment = n, X.Lazy = g, X.Memo = m, X.Portal = t, X.Profiler = i, X.StrictMode = o, X.Suspense = d, X.SuspenseList = h, X.isContextConsumer = function(u) {
      return e(u) === s;
    }, X.isContextProvider = function(u) {
      return e(u) === c;
    }, X.isElement = function(u) {
      return typeof u == "object" && u !== null && u.$$typeof === r;
    }, X.isForwardRef = function(u) {
      return e(u) === f;
    }, X.isFragment = function(u) {
      return e(u) === n;
    }, X.isLazy = function(u) {
      return e(u) === g;
    }, X.isMemo = function(u) {
      return e(u) === m;
    }, X.isPortal = function(u) {
      return e(u) === t;
    }, X.isProfiler = function(u) {
      return e(u) === i;
    }, X.isStrictMode = function(u) {
      return e(u) === o;
    }, X.isSuspense = function(u) {
      return e(u) === d;
    }, X.isSuspenseList = function(u) {
      return e(u) === h;
    }, X.isValidElementType = function(u) {
      return typeof u == "string" || typeof u == "function" || u === n || u === i || u === o || u === d || u === h || typeof u == "object" && u !== null && (u.$$typeof === g || u.$$typeof === m || u.$$typeof === c || u.$$typeof === s || u.$$typeof === f || u.$$typeof === v || u.getModuleId !== void 0);
    }, X.typeOf = e;
  }()), X;
}
var Ut;
function Ro() {
  return Ut || (Ut = 1, process.env.NODE_ENV === "production" ? ur.exports = /* @__PURE__ */ _o() : ur.exports = /* @__PURE__ */ Oo()), ur.exports;
}
var gr = /* @__PURE__ */ Ro();
function $e(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const r = Object.getPrototypeOf(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function hn(e) {
  if (/* @__PURE__ */ Ve.isValidElement(e) || gr.isValidElementType(e) || !$e(e))
    return e;
  const r = {};
  return Object.keys(e).forEach((t) => {
    r[t] = hn(e[t]);
  }), r;
}
function Se(e, r, t = {
  clone: !0
}) {
  const n = t.clone ? {
    ...e
  } : e;
  return $e(e) && $e(r) && Object.keys(r).forEach((o) => {
    /* @__PURE__ */ Ve.isValidElement(r[o]) || gr.isValidElementType(r[o]) ? n[o] = r[o] : $e(r[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && $e(e[o]) ? n[o] = Se(e[o], r[o], t) : t.clone ? n[o] = $e(r[o]) ? hn(r[o]) : r[o] : n[o] = r[o];
  }), n;
}
const $o = (e) => {
  const r = Object.keys(e).map((t) => ({
    key: t,
    val: e[t]
  })) || [];
  return r.sort((t, n) => t.val - n.val), r.reduce((t, n) => ({
    ...t,
    [n.key]: n.val
  }), {});
};
function ko(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: r = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: t = "px",
    step: n = 5,
    ...o
  } = e, i = $o(r), s = Object.keys(i);
  function c(g) {
    return `@media (min-width:${typeof r[g] == "number" ? r[g] : g}${t})`;
  }
  function f(g) {
    return `@media (max-width:${(typeof r[g] == "number" ? r[g] : g) - n / 100}${t})`;
  }
  function d(g, C) {
    const v = s.indexOf(C);
    return `@media (min-width:${typeof r[g] == "number" ? r[g] : g}${t}) and (max-width:${(v !== -1 && typeof r[s[v]] == "number" ? r[s[v]] : C) - n / 100}${t})`;
  }
  function h(g) {
    return s.indexOf(g) + 1 < s.length ? d(g, s[s.indexOf(g) + 1]) : c(g);
  }
  function m(g) {
    const C = s.indexOf(g);
    return C === 0 ? c(s[1]) : C === s.length - 1 ? f(s[C]) : d(g, s[s.indexOf(g) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: i,
    up: c,
    down: f,
    between: d,
    only: h,
    not: m,
    unit: t,
    ...o
  };
}
function Ao(e, r) {
  if (!e.containerQueries)
    return r;
  const t = Object.keys(r).filter((n) => n.startsWith("@container")).sort((n, o) => {
    var s, c;
    const i = /min-width:\s*([0-9.]+)/;
    return +(((s = n.match(i)) == null ? void 0 : s[1]) || 0) - +(((c = o.match(i)) == null ? void 0 : c[1]) || 0);
  });
  return t.length ? t.reduce((n, o) => {
    const i = r[o];
    return delete n[o], n[o] = i, n;
  }, {
    ...r
  }) : r;
}
function Po(e, r) {
  return r === "@" || r.startsWith("@") && (e.some((t) => r.startsWith(`@${t}`)) || !!r.match(/^@\d/));
}
function Io(e, r) {
  const t = r.match(/^@([^/]+)?\/?(.+)?$/);
  if (!t) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${r})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : Me(18, `(${r})`));
    return null;
  }
  const [, n, o] = t, i = Number.isNaN(+n) ? n || 0 : +n;
  return e.containerQueries(o).up(i);
}
function jo(e) {
  const r = (i, s) => i.replace("@media", s ? `@container ${s}` : "@container");
  function t(i, s) {
    i.up = (...c) => r(e.breakpoints.up(...c), s), i.down = (...c) => r(e.breakpoints.down(...c), s), i.between = (...c) => r(e.breakpoints.between(...c), s), i.only = (...c) => r(e.breakpoints.only(...c), s), i.not = (...c) => {
      const f = r(e.breakpoints.not(...c), s);
      return f.includes("not all and") ? f.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : f;
    };
  }
  const n = {}, o = (i) => (t(n, i), n);
  return t(o), {
    ...e,
    containerQueries: o
  };
}
const Mo = {
  borderRadius: 4
}, De = process.env.NODE_ENV !== "production" ? b.oneOfType([b.number, b.string, b.object, b.array]) : {};
function tr(e, r) {
  return r ? Se(e, r, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const vr = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Yt = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${vr[e]}px)`
}, No = {
  containerQueries: (e) => ({
    up: (r) => {
      let t = typeof r == "number" ? r : vr[r] || r;
      return typeof t == "number" && (t = `${t}px`), e ? `@container ${e} (min-width:${t})` : `@container (min-width:${t})`;
    }
  })
};
function Pe(e, r, t) {
  const n = e.theme || {};
  if (Array.isArray(r)) {
    const i = n.breakpoints || Yt;
    return r.reduce((s, c, f) => (s[i.up(i.keys[f])] = t(r[f]), s), {});
  }
  if (typeof r == "object") {
    const i = n.breakpoints || Yt;
    return Object.keys(r).reduce((s, c) => {
      if (Po(i.keys, c)) {
        const f = Io(n.containerQueries ? n : No, c);
        f && (s[f] = t(r[c], c));
      } else if (Object.keys(i.values || vr).includes(c)) {
        const f = i.up(c);
        s[f] = t(r[c], c);
      } else {
        const f = c;
        s[f] = r[f];
      }
      return s;
    }, {});
  }
  return t(r);
}
function Do(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, o) => {
    const i = e.up(o);
    return n[i] = {}, n;
  }, {})) || {};
}
function Bo(e, r) {
  return e.reduce((t, n) => {
    const o = t[n];
    return (!o || Object.keys(o).length === 0) && delete t[n], t;
  }, r);
}
function Fe(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Me(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function xr(e, r, t = !0) {
  if (!r || typeof r != "string")
    return null;
  if (e && e.vars && t) {
    const n = `vars.${r}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (n != null)
      return n;
  }
  return r.split(".").reduce((n, o) => n && n[o] != null ? n[o] : null, e);
}
function yr(e, r, t, n = t) {
  let o;
  return typeof e == "function" ? o = e(t) : Array.isArray(e) ? o = e[t] || n : o = xr(e, t) || n, r && (o = r(o, n, e)), o;
}
function le(e) {
  const {
    prop: r,
    cssProperty: t = e.prop,
    themeKey: n,
    transform: o
  } = e, i = (s) => {
    if (s[r] == null)
      return null;
    const c = s[r], f = s.theme, d = xr(f, n) || {};
    return Pe(s, c, (m) => {
      let g = yr(d, o, m);
      return m === g && typeof m == "string" && (g = yr(d, o, `${r}${m === "default" ? "" : Fe(m)}`, m)), t === !1 ? g : {
        [t]: g
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [r]: De
  } : {}, i.filterProps = [r], i;
}
function Fo(e) {
  const r = {};
  return (t) => (r[t] === void 0 && (r[t] = e(t)), r[t]);
}
const Vo = {
  m: "margin",
  p: "padding"
}, Lo = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, zt = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Wo = Fo((e) => {
  if (e.length > 2)
    if (zt[e])
      e = zt[e];
    else
      return [e];
  const [r, t] = e.split(""), n = Vo[r], o = Lo[t] || "";
  return Array.isArray(o) ? o.map((i) => n + i) : [n + o];
}), Sr = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Cr = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], qo = [...Sr, ...Cr];
function or(e, r, t, n) {
  const o = xr(e, r, !0) ?? t;
  return typeof o == "number" || typeof o == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${i}.`), typeof o == "string" ? `calc(${i} * ${o})` : o * i) : Array.isArray(o) ? (i) => {
    if (typeof i == "string")
      return i;
    const s = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(s) ? s > o.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${s} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${r}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${r}\` as a number.`].join(`
`)));
    const c = o[s];
    return i >= 0 ? c : typeof c == "number" ? -c : `-${c}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${r}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function nt(e) {
  return or(e, "spacing", 8, "spacing");
}
function ir(e, r) {
  return typeof r == "string" || r == null ? r : e(r);
}
function Uo(e, r) {
  return (t) => e.reduce((n, o) => (n[o] = ir(r, t), n), {});
}
function Yo(e, r, t, n) {
  if (!r.includes(t))
    return null;
  const o = Wo(t), i = Uo(o, n), s = e[t];
  return Pe(e, s, i);
}
function gn(e, r) {
  const t = nt(e.theme);
  return Object.keys(e).map((n) => Yo(e, r, n, t)).reduce(tr, {});
}
function ae(e) {
  return gn(e, Sr);
}
ae.propTypes = process.env.NODE_ENV !== "production" ? Sr.reduce((e, r) => (e[r] = De, e), {}) : {};
ae.filterProps = Sr;
function se(e) {
  return gn(e, Cr);
}
se.propTypes = process.env.NODE_ENV !== "production" ? Cr.reduce((e, r) => (e[r] = De, e), {}) : {};
se.filterProps = Cr;
process.env.NODE_ENV !== "production" && qo.reduce((e, r) => (e[r] = De, e), {});
function yn(e = 8, r = nt({
  spacing: e
})) {
  if (e.mui)
    return e;
  const t = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((i) => {
    const s = r(i);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return t.mui = !0, t;
}
function Er(...e) {
  const r = e.reduce((n, o) => (o.filterProps.forEach((i) => {
    n[i] = o;
  }), n), {}), t = (n) => Object.keys(n).reduce((o, i) => r[i] ? tr(o, r[i](n)) : o, {});
  return t.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, o) => Object.assign(n, o.propTypes), {}) : {}, t.filterProps = e.reduce((n, o) => n.concat(o.filterProps), []), t;
}
function Ce(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Ee(e, r) {
  return le({
    prop: e,
    themeKey: "borders",
    transform: r
  });
}
const zo = Ee("border", Ce), Go = Ee("borderTop", Ce), Zo = Ee("borderRight", Ce), Ko = Ee("borderBottom", Ce), Ho = Ee("borderLeft", Ce), Jo = Ee("borderColor"), Qo = Ee("borderTopColor"), Xo = Ee("borderRightColor"), ei = Ee("borderBottomColor"), ri = Ee("borderLeftColor"), ti = Ee("outline", Ce), ni = Ee("outlineColor"), wr = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const r = or(e.theme, "shape.borderRadius", 4, "borderRadius"), t = (n) => ({
      borderRadius: ir(r, n)
    });
    return Pe(e, e.borderRadius, t);
  }
  return null;
};
wr.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: De
} : {};
wr.filterProps = ["borderRadius"];
Er(zo, Go, Zo, Ko, Ho, Jo, Qo, Xo, ei, ri, wr, ti, ni);
const Tr = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const r = or(e.theme, "spacing", 8, "gap"), t = (n) => ({
      gap: ir(r, n)
    });
    return Pe(e, e.gap, t);
  }
  return null;
};
Tr.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: De
} : {};
Tr.filterProps = ["gap"];
const _r = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const r = or(e.theme, "spacing", 8, "columnGap"), t = (n) => ({
      columnGap: ir(r, n)
    });
    return Pe(e, e.columnGap, t);
  }
  return null;
};
_r.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: De
} : {};
_r.filterProps = ["columnGap"];
const Or = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const r = or(e.theme, "spacing", 8, "rowGap"), t = (n) => ({
      rowGap: ir(r, n)
    });
    return Pe(e, e.rowGap, t);
  }
  return null;
};
Or.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: De
} : {};
Or.filterProps = ["rowGap"];
const oi = le({
  prop: "gridColumn"
}), ii = le({
  prop: "gridRow"
}), ai = le({
  prop: "gridAutoFlow"
}), si = le({
  prop: "gridAutoColumns"
}), ci = le({
  prop: "gridAutoRows"
}), li = le({
  prop: "gridTemplateColumns"
}), ui = le({
  prop: "gridTemplateRows"
}), fi = le({
  prop: "gridTemplateAreas"
}), di = le({
  prop: "gridArea"
});
Er(Tr, _r, Or, oi, ii, ai, si, ci, li, ui, fi, di);
function Je(e, r) {
  return r === "grey" ? r : e;
}
const pi = le({
  prop: "color",
  themeKey: "palette",
  transform: Je
}), mi = le({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Je
}), hi = le({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Je
});
Er(pi, mi, hi);
function xe(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const gi = le({
  prop: "width",
  transform: xe
}), ot = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const r = (t) => {
      var o, i, s, c, f;
      const n = ((s = (i = (o = e.theme) == null ? void 0 : o.breakpoints) == null ? void 0 : i.values) == null ? void 0 : s[t]) || vr[t];
      return n ? ((f = (c = e.theme) == null ? void 0 : c.breakpoints) == null ? void 0 : f.unit) !== "px" ? {
        maxWidth: `${n}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: n
      } : {
        maxWidth: xe(t)
      };
    };
    return Pe(e, e.maxWidth, r);
  }
  return null;
};
ot.filterProps = ["maxWidth"];
const yi = le({
  prop: "minWidth",
  transform: xe
}), bi = le({
  prop: "height",
  transform: xe
}), vi = le({
  prop: "maxHeight",
  transform: xe
}), xi = le({
  prop: "minHeight",
  transform: xe
});
le({
  prop: "size",
  cssProperty: "width",
  transform: xe
});
le({
  prop: "size",
  cssProperty: "height",
  transform: xe
});
const Si = le({
  prop: "boxSizing"
});
Er(gi, ot, yi, bi, vi, xi, Si);
const Rr = {
  // borders
  border: {
    themeKey: "borders",
    transform: Ce
  },
  borderTop: {
    themeKey: "borders",
    transform: Ce
  },
  borderRight: {
    themeKey: "borders",
    transform: Ce
  },
  borderBottom: {
    themeKey: "borders",
    transform: Ce
  },
  borderLeft: {
    themeKey: "borders",
    transform: Ce
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Ce
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: wr
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Je
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Je
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Je
  },
  // spacing
  p: {
    style: se
  },
  pt: {
    style: se
  },
  pr: {
    style: se
  },
  pb: {
    style: se
  },
  pl: {
    style: se
  },
  px: {
    style: se
  },
  py: {
    style: se
  },
  padding: {
    style: se
  },
  paddingTop: {
    style: se
  },
  paddingRight: {
    style: se
  },
  paddingBottom: {
    style: se
  },
  paddingLeft: {
    style: se
  },
  paddingX: {
    style: se
  },
  paddingY: {
    style: se
  },
  paddingInline: {
    style: se
  },
  paddingInlineStart: {
    style: se
  },
  paddingInlineEnd: {
    style: se
  },
  paddingBlock: {
    style: se
  },
  paddingBlockStart: {
    style: se
  },
  paddingBlockEnd: {
    style: se
  },
  m: {
    style: ae
  },
  mt: {
    style: ae
  },
  mr: {
    style: ae
  },
  mb: {
    style: ae
  },
  ml: {
    style: ae
  },
  mx: {
    style: ae
  },
  my: {
    style: ae
  },
  margin: {
    style: ae
  },
  marginTop: {
    style: ae
  },
  marginRight: {
    style: ae
  },
  marginBottom: {
    style: ae
  },
  marginLeft: {
    style: ae
  },
  marginX: {
    style: ae
  },
  marginY: {
    style: ae
  },
  marginInline: {
    style: ae
  },
  marginInlineStart: {
    style: ae
  },
  marginInlineEnd: {
    style: ae
  },
  marginBlock: {
    style: ae
  },
  marginBlockStart: {
    style: ae
  },
  marginBlockEnd: {
    style: ae
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Tr
  },
  rowGap: {
    style: Or
  },
  columnGap: {
    style: _r
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: xe
  },
  maxWidth: {
    style: ot
  },
  minWidth: {
    transform: xe
  },
  height: {
    transform: xe
  },
  maxHeight: {
    transform: xe
  },
  minHeight: {
    transform: xe
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function Ci(...e) {
  const r = e.reduce((n, o) => n.concat(Object.keys(o)), []), t = new Set(r);
  return e.every((n) => t.size === Object.keys(n).length);
}
function Ei(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function wi() {
  function e(t, n, o, i) {
    const s = {
      [t]: n,
      theme: o
    }, c = i[t];
    if (!c)
      return {
        [t]: n
      };
    const {
      cssProperty: f = t,
      themeKey: d,
      transform: h,
      style: m
    } = c;
    if (n == null)
      return null;
    if (d === "typography" && n === "inherit")
      return {
        [t]: n
      };
    const g = xr(o, d) || {};
    return m ? m(s) : Pe(s, n, (v) => {
      let u = yr(g, h, v);
      return v === u && typeof v == "string" && (u = yr(g, h, `${t}${v === "default" ? "" : Fe(v)}`, v)), f === !1 ? u : {
        [f]: u
      };
    });
  }
  function r(t) {
    const {
      sx: n,
      theme: o = {}
    } = t || {};
    if (!n)
      return null;
    const i = o.unstable_sxConfig ?? Rr;
    function s(c) {
      let f = c;
      if (typeof c == "function")
        f = c(o);
      else if (typeof c != "object")
        return c;
      if (!f)
        return null;
      const d = Do(o.breakpoints), h = Object.keys(d);
      let m = d;
      return Object.keys(f).forEach((g) => {
        const C = Ei(f[g], o);
        if (C != null)
          if (typeof C == "object")
            if (i[g])
              m = tr(m, e(g, C, o, i));
            else {
              const v = Pe({
                theme: o
              }, C, (u) => ({
                [g]: u
              }));
              Ci(v, C) ? m[g] = r({
                sx: C,
                theme: o
              }) : m = tr(m, v);
            }
          else
            m = tr(m, e(g, C, o, i));
      }), Ao(o, Bo(h, m));
    }
    return Array.isArray(n) ? n.map(s) : s(n);
  }
  return r;
}
const Qe = wi();
Qe.filterProps = ["sx"];
function Ti(e, r) {
  var n;
  const t = this;
  if (t.vars) {
    if (!((n = t.colorSchemes) != null && n[e]) || typeof t.getColorSchemeSelector != "function")
      return {};
    let o = t.getColorSchemeSelector(e);
    return o === "&" ? r : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: r
    });
  }
  return t.palette.mode === e ? r : {};
}
function it(e = {}, ...r) {
  const {
    breakpoints: t = {},
    palette: n = {},
    spacing: o,
    shape: i = {},
    ...s
  } = e, c = ko(t), f = yn(o);
  let d = Se({
    breakpoints: c,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...n
    },
    spacing: f,
    shape: {
      ...Mo,
      ...i
    }
  }, s);
  return d = jo(d), d.applyStyles = Ti, d = r.reduce((h, m) => Se(h, m), d), d.unstable_sxConfig = {
    ...Rr,
    ...s == null ? void 0 : s.unstable_sxConfig
  }, d.unstable_sx = function(m) {
    return Qe({
      sx: m,
      theme: this
    });
  }, d;
}
function _i(e) {
  return Object.keys(e).length === 0;
}
function Oi(e = null) {
  const r = Ve.useContext(no);
  return !r || _i(r) ? e : r;
}
const Ri = it();
function $i(e = Ri) {
  return Oi(e);
}
const Gt = (e) => e, ki = () => {
  let e = Gt;
  return {
    configure(r) {
      e = r;
    },
    generate(r) {
      return e(r);
    },
    reset() {
      e = Gt;
    }
  };
}, Ai = ki();
function bn(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (r = 0; r < o; r++) e[r] && (t = bn(e[r])) && (n && (n += " "), n += t);
  } else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function Pi() {
  for (var e, r, t = 0, n = "", o = arguments.length; t < o; t++) (e = arguments[t]) && (r = bn(e)) && (n && (n += " "), n += r);
  return n;
}
const Ii = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function at(e, r, t = "Mui") {
  const n = Ii[r];
  return n ? `${t}-${n}` : `${Ai.generate(e)}-${r}`;
}
function ji(e, r, t = "Mui") {
  const n = {};
  return r.forEach((o) => {
    n[o] = at(e, o, t);
  }), n;
}
function vn(e, r = "") {
  return e.displayName || e.name || r;
}
function Zt(e, r, t) {
  const n = vn(r);
  return e.displayName || (n !== "" ? `${t}(${n})` : t);
}
function Mi(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return vn(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case gr.ForwardRef:
          return Zt(e, e.render, "ForwardRef");
        case gr.Memo:
          return Zt(e, e.type, "memo");
        default:
          return;
      }
  }
}
function xn(e) {
  const {
    variants: r,
    ...t
  } = e, n = {
    variants: r,
    style: Lt(t),
    isProcessed: !0
  };
  return n.style === t || r && r.forEach((o) => {
    typeof o.style != "function" && (o.style = Lt(o.style));
  }), n;
}
const Ni = it();
function ke(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function Di(e) {
  return e ? (r, t) => t[e] : null;
}
function Bi(e, r, t) {
  e.theme = Wi(e.theme) ? t : e.theme[r] || e.theme;
}
function mr(e, r) {
  const t = typeof r == "function" ? r(e) : r;
  if (Array.isArray(t))
    return t.flatMap((n) => mr(e, n));
  if (Array.isArray(t == null ? void 0 : t.variants)) {
    let n;
    if (t.isProcessed)
      n = t.style;
    else {
      const {
        variants: o,
        ...i
      } = t;
      n = i;
    }
    return Sn(e, t.variants, [n]);
  }
  return t != null && t.isProcessed ? t.style : t;
}
function Sn(e, r, t = []) {
  var o;
  let n;
  e: for (let i = 0; i < r.length; i += 1) {
    const s = r[i];
    if (typeof s.props == "function") {
      if (n ?? (n = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !s.props(n))
        continue;
    } else
      for (const c in s.props)
        if (e[c] !== s.props[c] && ((o = e.ownerState) == null ? void 0 : o[c]) !== s.props[c])
          continue e;
    typeof s.style == "function" ? (n ?? (n = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), t.push(s.style(n))) : t.push(s.style);
  }
  return t;
}
function Fi(e = {}) {
  const {
    themeId: r,
    defaultTheme: t = Ni,
    rootShouldForwardProp: n = ke,
    slotShouldForwardProp: o = ke
  } = e;
  function i(c) {
    Bi(c, r, t);
  }
  return (c, f = {}) => {
    To(c, (y) => y.filter((G) => G !== Qe));
    const {
      name: d,
      slot: h,
      skipVariantsResolver: m,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: C = Di(Cn(h)),
      ...v
    } = f, u = m !== void 0 ? m : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      h && h !== "Root" && h !== "root" || !1
    ), R = g || !1;
    let k = ke;
    h === "Root" || h === "root" ? k = n : h ? k = o : qi(c) && (k = void 0);
    const F = wo(c, {
      shouldForwardProp: k,
      label: Li(d, h),
      ...v
    }), E = (y) => {
      if (typeof y == "function" && y.__emotion_real !== y)
        return function(ne) {
          return mr(ne, y);
        };
      if ($e(y)) {
        const G = xn(y);
        return G.variants ? function(Z) {
          return mr(Z, G);
        } : G.style;
      }
      return y;
    }, T = (...y) => {
      const G = [], ne = y.map(E), Z = [];
      if (G.push(i), d && C && Z.push(function(I) {
        var pe, be;
        const K = (be = (pe = I.theme.components) == null ? void 0 : pe[d]) == null ? void 0 : be.styleOverrides;
        if (!K)
          return null;
        const fe = {};
        for (const we in K)
          fe[we] = mr(I, K[we]);
        return C(I, fe);
      }), d && !u && Z.push(function(I) {
        var fe, pe;
        const U = I.theme, K = (pe = (fe = U == null ? void 0 : U.components) == null ? void 0 : fe[d]) == null ? void 0 : pe.variants;
        return K ? Sn(I, K) : null;
      }), R || Z.push(Qe), Array.isArray(ne[0])) {
        const $ = ne.shift(), I = new Array(G.length).fill(""), U = new Array(Z.length).fill("");
        let K;
        K = [...I, ...$, ...U], K.raw = [...I, ...$.raw, ...U], G.unshift(K);
      }
      const me = [...G, ...ne, ...Z], a = F(...me);
      return c.muiName && (a.muiName = c.muiName), process.env.NODE_ENV !== "production" && (a.displayName = Vi(d, h, c)), a;
    };
    return F.withConfig && (T.withConfig = F.withConfig), T;
  };
}
function Vi(e, r, t) {
  return e ? `${e}${Fe(r || "")}` : `Styled(${Mi(t)})`;
}
function Li(e, r) {
  let t;
  return process.env.NODE_ENV !== "production" && e && (t = `${e}-${Cn(r || "Root")}`), t;
}
function Wi(e) {
  for (const r in e)
    return !1;
  return !0;
}
function qi(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Cn(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function Yr(e, r) {
  const t = {
    ...r
  };
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      const o = n;
      if (o === "components" || o === "slots")
        t[o] = {
          ...e[o],
          ...t[o]
        };
      else if (o === "componentsProps" || o === "slotProps") {
        const i = e[o], s = r[o];
        if (!s)
          t[o] = i || {};
        else if (!i)
          t[o] = s;
        else {
          t[o] = {
            ...s
          };
          for (const c in i)
            if (Object.prototype.hasOwnProperty.call(i, c)) {
              const f = c;
              t[o][f] = Yr(i[f], s[f]);
            }
        }
      } else t[o] === void 0 && (t[o] = e[o]);
    }
  return t;
}
function Ui(e, r = Number.MIN_SAFE_INTEGER, t = Number.MAX_SAFE_INTEGER) {
  return Math.max(r, Math.min(e, t));
}
function st(e, r = 0, t = 1) {
  return process.env.NODE_ENV !== "production" && (e < r || e > t) && console.error(`MUI: The value provided ${e} is out of range [${r}, ${t}].`), Ui(e, r, t);
}
function Yi(e) {
  e = e.slice(1);
  const r = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let t = e.match(r);
  return t && t[0].length === 1 && (t = t.map((n) => n + n)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), t ? `rgb${t.length === 4 ? "a" : ""}(${t.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Ne(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Ne(Yi(e));
  const r = e.indexOf("("), t = e.substring(0, r);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(t))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Me(9, e));
  let n = e.substring(r + 1, e.length - 1), o;
  if (t === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Me(10, o));
  } else
    n = n.split(",");
  return n = n.map((i) => parseFloat(i)), {
    type: t,
    values: n,
    colorSpace: o
  };
}
const zi = (e) => {
  const r = Ne(e);
  return r.values.slice(0, 3).map((t, n) => r.type.includes("hsl") && n !== 0 ? `${t}%` : t).join(" ");
}, er = (e, r) => {
  try {
    return zi(e);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
};
function $r(e) {
  const {
    type: r,
    colorSpace: t
  } = e;
  let {
    values: n
  } = e;
  return r.includes("rgb") ? n = n.map((o, i) => i < 3 ? parseInt(o, 10) : o) : r.includes("hsl") && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), r.includes("color") ? n = `${t} ${n.join(" ")}` : n = `${n.join(", ")}`, `${r}(${n})`;
}
function En(e) {
  e = Ne(e);
  const {
    values: r
  } = e, t = r[0], n = r[1] / 100, o = r[2] / 100, i = n * Math.min(o, 1 - o), s = (d, h = (d + t / 30) % 12) => o - i * Math.max(Math.min(h - 3, 9 - h, 1), -1);
  let c = "rgb";
  const f = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (c += "a", f.push(r[3])), $r({
    type: c,
    values: f
  });
}
function zr(e) {
  e = Ne(e);
  let r = e.type === "hsl" || e.type === "hsla" ? Ne(En(e)).values : e.values;
  return r = r.map((t) => (e.type !== "color" && (t /= 255), t <= 0.03928 ? t / 12.92 : ((t + 0.055) / 1.055) ** 2.4)), Number((0.2126 * r[0] + 0.7152 * r[1] + 0.0722 * r[2]).toFixed(3));
}
function Kt(e, r) {
  const t = zr(e), n = zr(r);
  return (Math.max(t, n) + 0.05) / (Math.min(t, n) + 0.05);
}
function Gi(e, r) {
  return e = Ne(e), r = st(r), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${r}` : e.values[3] = r, $r(e);
}
function fr(e, r, t) {
  try {
    return Gi(e, r);
  } catch {
    return e;
  }
}
function ct(e, r) {
  if (e = Ne(e), r = st(r), e.type.includes("hsl"))
    e.values[2] *= 1 - r;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let t = 0; t < 3; t += 1)
      e.values[t] *= 1 - r;
  return $r(e);
}
function re(e, r, t) {
  try {
    return ct(e, r);
  } catch {
    return e;
  }
}
function lt(e, r) {
  if (e = Ne(e), r = st(r), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * r;
  else if (e.type.includes("rgb"))
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (255 - e.values[t]) * r;
  else if (e.type.includes("color"))
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (1 - e.values[t]) * r;
  return $r(e);
}
function te(e, r, t) {
  try {
    return lt(e, r);
  } catch {
    return e;
  }
}
function Zi(e, r = 0.15) {
  return zr(e) > 0.5 ? ct(e, r) : lt(e, r);
}
function dr(e, r, t) {
  try {
    return Zi(e, r);
  } catch {
    return e;
  }
}
function Ki(e, r) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || r(...n);
  };
}
function Hi(e, r, t = void 0) {
  const n = {};
  for (const o in e) {
    const i = e[o];
    let s = "", c = !0;
    for (let f = 0; f < i.length; f += 1) {
      const d = i[f];
      d && (s += (c === !0 ? "" : " ") + r(d), c = !1, t && t[d] && (s += " " + t[d]));
    }
    n[o] = s;
  }
  return n;
}
const Ji = /* @__PURE__ */ Ve.createContext(void 0);
process.env.NODE_ENV !== "production" && (b.node, b.object);
function Qi(e) {
  const {
    theme: r,
    name: t,
    props: n
  } = e;
  if (!r || !r.components || !r.components[t])
    return n;
  const o = r.components[t];
  return o.defaultProps ? Yr(o.defaultProps, n) : !o.styleOverrides && !o.variants ? Yr(o, n) : n;
}
function Xi({
  props: e,
  name: r
}) {
  const t = Ve.useContext(Ji);
  return Qi({
    props: e,
    name: r,
    theme: {
      components: t
    }
  });
}
const Ht = {
  theme: void 0
};
function ea(e) {
  let r, t;
  return function(o) {
    let i = r;
    return (i === void 0 || o.theme !== t) && (Ht.theme = o.theme, i = xn(e(Ht)), r = i, t = o.theme), i;
  };
}
function ra(e = "") {
  function r(...n) {
    if (!n.length)
      return "";
    const o = n[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${o}${r(...n.slice(1))})` : `, ${o}`;
  }
  return (n, ...o) => `var(--${e ? `${e}-` : ""}${n}${r(...o)})`;
}
const Jt = (e, r, t, n = []) => {
  let o = e;
  r.forEach((i, s) => {
    s === r.length - 1 ? Array.isArray(o) ? o[Number(i)] = t : o && typeof o == "object" && (o[i] = t) : o && typeof o == "object" && (o[i] || (o[i] = n.includes(i) ? [] : {}), o = o[i]);
  });
}, ta = (e, r, t) => {
  function n(o, i = [], s = []) {
    Object.entries(o).forEach(([c, f]) => {
      (!t || t && !t([...i, c])) && f != null && (typeof f == "object" && Object.keys(f).length > 0 ? n(f, [...i, c], Array.isArray(f) ? [...s, c] : s) : r([...i, c], f, s));
    });
  }
  n(e);
}, na = (e, r) => typeof r == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((n) => e.includes(n)) || e[e.length - 1].toLowerCase().includes("opacity") ? r : `${r}px` : r;
function Wr(e, r) {
  const {
    prefix: t,
    shouldSkipGeneratingVar: n
  } = r || {}, o = {}, i = {}, s = {};
  return ta(
    e,
    (c, f, d) => {
      if ((typeof f == "string" || typeof f == "number") && (!n || !n(c, f))) {
        const h = `--${t ? `${t}-` : ""}${c.join("-")}`, m = na(c, f);
        Object.assign(o, {
          [h]: m
        }), Jt(i, c, `var(${h})`, d), Jt(s, c, `var(${h}, ${m})`, d);
      }
    },
    (c) => c[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: i,
    varsWithDefaults: s
  };
}
function oa(e, r = {}) {
  const {
    getSelector: t = R,
    disableCssColorScheme: n,
    colorSchemeSelector: o
  } = r, {
    colorSchemes: i = {},
    components: s,
    defaultColorScheme: c = "light",
    ...f
  } = e, {
    vars: d,
    css: h,
    varsWithDefaults: m
  } = Wr(f, r);
  let g = m;
  const C = {}, {
    [c]: v,
    ...u
  } = i;
  if (Object.entries(u || {}).forEach(([E, T]) => {
    const {
      vars: y,
      css: G,
      varsWithDefaults: ne
    } = Wr(T, r);
    g = Se(g, ne), C[E] = {
      css: G,
      vars: y
    };
  }), v) {
    const {
      css: E,
      vars: T,
      varsWithDefaults: y
    } = Wr(v, r);
    g = Se(g, y), C[c] = {
      css: E,
      vars: T
    };
  }
  function R(E, T) {
    var G, ne;
    let y = o;
    if (o === "class" && (y = ".%s"), o === "data" && (y = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (y = `[${o}="%s"]`), E) {
      if (y === "media")
        return e.defaultColorScheme === E ? ":root" : {
          [`@media (prefers-color-scheme: ${((ne = (G = i[E]) == null ? void 0 : G.palette) == null ? void 0 : ne.mode) || E})`]: {
            ":root": T
          }
        };
      if (y)
        return e.defaultColorScheme === E ? `:root, ${y.replace("%s", String(E))}` : y.replace("%s", String(E));
    }
    return ":root";
  }
  return {
    vars: g,
    generateThemeVars: () => {
      let E = {
        ...d
      };
      return Object.entries(C).forEach(([, {
        vars: T
      }]) => {
        E = Se(E, T);
      }), E;
    },
    generateStyleSheets: () => {
      var Z, me;
      const E = [], T = e.defaultColorScheme || "light";
      function y(a, $) {
        Object.keys($).length && E.push(typeof a == "string" ? {
          [a]: {
            ...$
          }
        } : a);
      }
      y(t(void 0, {
        ...h
      }), h);
      const {
        [T]: G,
        ...ne
      } = C;
      if (G) {
        const {
          css: a
        } = G, $ = (me = (Z = i[T]) == null ? void 0 : Z.palette) == null ? void 0 : me.mode, I = !n && $ ? {
          colorScheme: $,
          ...a
        } : {
          ...a
        };
        y(t(T, {
          ...I
        }), I);
      }
      return Object.entries(ne).forEach(([a, {
        css: $
      }]) => {
        var K, fe;
        const I = (fe = (K = i[a]) == null ? void 0 : K.palette) == null ? void 0 : fe.mode, U = !n && I ? {
          colorScheme: I,
          ...$
        } : {
          ...$
        };
        y(t(a, {
          ...U
        }), U);
      }), E;
    }
  };
}
function ia(e) {
  return function(t) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && t !== "light" && t !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${t}'.`), `@media (prefers-color-scheme: ${t})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${t}"] &` : e === "class" ? `.${t} &` : e === "data" ? `[data-${t}] &` : `${e.replace("%s", t)} &` : "&";
  };
}
const nr = {
  black: "#000",
  white: "#fff"
}, aa = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, ze = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, Ge = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Xe = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Ze = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, Ke = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, He = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function wn() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: nr.white,
      default: nr.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const sa = wn();
function Tn() {
  return {
    text: {
      primary: nr.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: nr.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const Qt = Tn();
function Xt(e, r, t, n) {
  const o = n.light || n, i = n.dark || n * 1.5;
  e[r] || (e.hasOwnProperty(t) ? e[r] = e[t] : r === "light" ? e.light = lt(e.main, o) : r === "dark" && (e.dark = ct(e.main, i)));
}
function ca(e = "light") {
  return e === "dark" ? {
    main: Ze[200],
    light: Ze[50],
    dark: Ze[400]
  } : {
    main: Ze[700],
    light: Ze[400],
    dark: Ze[800]
  };
}
function la(e = "light") {
  return e === "dark" ? {
    main: ze[200],
    light: ze[50],
    dark: ze[400]
  } : {
    main: ze[500],
    light: ze[300],
    dark: ze[700]
  };
}
function ua(e = "light") {
  return e === "dark" ? {
    main: Ge[500],
    light: Ge[300],
    dark: Ge[700]
  } : {
    main: Ge[700],
    light: Ge[400],
    dark: Ge[800]
  };
}
function fa(e = "light") {
  return e === "dark" ? {
    main: Ke[400],
    light: Ke[300],
    dark: Ke[700]
  } : {
    main: Ke[700],
    light: Ke[500],
    dark: Ke[900]
  };
}
function da(e = "light") {
  return e === "dark" ? {
    main: He[400],
    light: He[300],
    dark: He[700]
  } : {
    main: He[800],
    light: He[500],
    dark: He[900]
  };
}
function pa(e = "light") {
  return e === "dark" ? {
    main: Xe[400],
    light: Xe[300],
    dark: Xe[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Xe[500],
    dark: Xe[900]
  };
}
function ut(e) {
  const {
    mode: r = "light",
    contrastThreshold: t = 3,
    tonalOffset: n = 0.2,
    ...o
  } = e, i = e.primary || ca(r), s = e.secondary || la(r), c = e.error || ua(r), f = e.info || fa(r), d = e.success || da(r), h = e.warning || pa(r);
  function m(u) {
    const R = Kt(u, Qt.text.primary) >= t ? Qt.text.primary : sa.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const k = Kt(u, R);
      k < 3 && console.error([`MUI: The contrast ratio of ${k}:1 for ${R} on ${u}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return R;
  }
  const g = ({
    color: u,
    name: R,
    mainShade: k = 500,
    lightShade: F = 300,
    darkShade: E = 700
  }) => {
    if (u = {
      ...u
    }, !u.main && u[k] && (u.main = u[k]), !u.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${R ? ` (${R})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${k}\` property.` : Me(11, R ? ` (${R})` : "", k));
    if (typeof u.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${R ? ` (${R})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(u.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Me(12, R ? ` (${R})` : "", JSON.stringify(u.main)));
    return Xt(u, "light", F, n), Xt(u, "dark", E, n), u.contrastText || (u.contrastText = m(u.main)), u;
  };
  let C;
  return r === "light" ? C = wn() : r === "dark" && (C = Tn()), process.env.NODE_ENV !== "production" && (C || console.error(`MUI: The palette mode \`${r}\` is not supported.`)), Se({
    // A collection of common colors.
    common: {
      ...nr
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: r,
    // The colors used to represent primary interface elements for a user.
    primary: g({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: g({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: g({
      color: c,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: g({
      color: h,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: g({
      color: f,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: g({
      color: d,
      name: "success"
    }),
    // The grey colors.
    grey: aa,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: t,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: m,
    // Generate a rich color object.
    augmentColor: g,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n,
    // The light and dark mode object.
    ...C
  }, o);
}
function ma(e) {
  const r = {};
  return Object.entries(e).forEach((n) => {
    const [o, i] = n;
    typeof i == "object" && (r[o] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), r;
}
function ha(e, r) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...r
  };
}
function ga(e) {
  return Math.round(e * 1e5) / 1e5;
}
const en = {
  textTransform: "uppercase"
}, rn = '"Roboto", "Helvetica", "Arial", sans-serif';
function ya(e, r) {
  const {
    fontFamily: t = rn,
    // The default font size of the Material Specification.
    fontSize: n = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: f = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: h,
    ...m
  } = typeof r == "function" ? r(e) : r;
  process.env.NODE_ENV !== "production" && (typeof n != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof f != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = n / 14, C = h || ((R) => `${R / f * g}rem`), v = (R, k, F, E, T) => ({
    fontFamily: t,
    fontWeight: R,
    fontSize: C(k),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: F,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...t === rn ? {
      letterSpacing: `${ga(E / k)}em`
    } : {},
    ...T,
    ...d
  }), u = {
    h1: v(o, 96, 1.167, -1.5),
    h2: v(o, 60, 1.2, -0.5),
    h3: v(i, 48, 1.167, 0),
    h4: v(i, 34, 1.235, 0.25),
    h5: v(i, 24, 1.334, 0),
    h6: v(s, 20, 1.6, 0.15),
    subtitle1: v(i, 16, 1.75, 0.15),
    subtitle2: v(s, 14, 1.57, 0.1),
    body1: v(i, 16, 1.5, 0.15),
    body2: v(i, 14, 1.43, 0.15),
    button: v(s, 14, 1.75, 0.4, en),
    caption: v(i, 12, 1.66, 0.4),
    overline: v(i, 12, 2.66, 1, en),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Se({
    htmlFontSize: f,
    pxToRem: C,
    fontFamily: t,
    fontSize: n,
    fontWeightLight: o,
    fontWeightRegular: i,
    fontWeightMedium: s,
    fontWeightBold: c,
    ...u
  }, m, {
    clone: !1
    // No need to clone deep
  });
}
const ba = 0.2, va = 0.14, xa = 0.12;
function ie(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${ba})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${va})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${xa})`].join(",");
}
const Sa = ["none", ie(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ie(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ie(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ie(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ie(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ie(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ie(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ie(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ie(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ie(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ie(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ie(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ie(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ie(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ie(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ie(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ie(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ie(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ie(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ie(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ie(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ie(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ie(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ie(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], Ca = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Ea = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function tn(e) {
  return `${Math.round(e)}ms`;
}
function wa(e) {
  if (!e)
    return 0;
  const r = e / 36;
  return Math.min(Math.round((4 + 15 * r ** 0.25 + r / 5) * 10), 3e3);
}
function Ta(e) {
  const r = {
    ...Ca,
    ...e.easing
  }, t = {
    ...Ea,
    ...e.duration
  };
  return {
    getAutoHeightDuration: wa,
    create: (o = ["all"], i = {}) => {
      const {
        duration: s = t.standard,
        easing: c = r.easeInOut,
        delay: f = 0,
        ...d
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const h = (g) => typeof g == "string", m = (g) => !Number.isNaN(parseFloat(g));
        !h(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !m(s) && !h(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), h(c) || console.error('MUI: Argument "easing" must be a string.'), !m(f) && !h(f) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(d).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(d).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((h) => `${h} ${typeof s == "string" ? s : tn(s)} ${c} ${typeof f == "string" ? f : tn(f)}`).join(",");
    },
    ...e,
    easing: r,
    duration: t
  };
}
const _a = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function Oa(e) {
  return $e(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function _n(e = {}) {
  const r = {
    ...e
  };
  function t(n) {
    const o = Object.entries(n);
    for (let i = 0; i < o.length; i++) {
      const [s, c] = o[i];
      !Oa(c) || s.startsWith("unstable_") ? delete n[s] : $e(c) && (n[s] = {
        ...c
      }, t(n[s]));
    }
  }
  return t(r), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(r, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Gr(e = {}, ...r) {
  const {
    breakpoints: t,
    mixins: n = {},
    spacing: o,
    palette: i = {},
    transitions: s = {},
    typography: c = {},
    shape: f,
    ...d
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : Me(20));
  const h = ut(i), m = it(e);
  let g = Se(m, {
    mixins: ha(m.breakpoints, n),
    palette: h,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Sa.slice(),
    typography: ya(h, c),
    transitions: Ta(s),
    zIndex: {
      ..._a
    }
  });
  if (g = Se(g, d), g = r.reduce((C, v) => Se(C, v), g), process.env.NODE_ENV !== "production") {
    const C = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], v = (u, R) => {
      let k;
      for (k in u) {
        const F = u[k];
        if (C.includes(k) && Object.keys(F).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const E = at("", k);
            console.error([`MUI: The \`${R}\` component increases the CSS specificity of the \`${k}\` internal state.`, "You can not override it like this: ", JSON.stringify(u, null, 2), "", `Instead, you need to use the '&.${E}' syntax:`, JSON.stringify({
              root: {
                [`&.${E}`]: F
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          u[k] = {};
        }
      }
    };
    Object.keys(g.components).forEach((u) => {
      const R = g.components[u].styleOverrides;
      R && u.startsWith("Mui") && v(R, u);
    });
  }
  return g.unstable_sxConfig = {
    ...Rr,
    ...d == null ? void 0 : d.unstable_sxConfig
  }, g.unstable_sx = function(v) {
    return Qe({
      sx: v,
      theme: this
    });
  }, g.toRuntimeSource = _n, g;
}
function Ra(e) {
  let r;
  return e < 1 ? r = 5.11916 * e ** 2 : r = 4.5 * Math.log(e + 1) + 2, Math.round(r * 10) / 1e3;
}
const $a = [...Array(25)].map((e, r) => {
  if (r === 0)
    return "none";
  const t = Ra(r);
  return `linear-gradient(rgba(255 255 255 / ${t}), rgba(255 255 255 / ${t}))`;
});
function On(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Rn(e) {
  return e === "dark" ? $a : [];
}
function ka(e) {
  const {
    palette: r = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: t,
    overlays: n,
    ...o
  } = e, i = ut(r);
  return {
    palette: i,
    opacity: {
      ...On(i.mode),
      ...t
    },
    overlays: n || Rn(i.mode),
    ...o
  };
}
function Aa(e) {
  var r;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((r = e[1]) != null && r.match(/(mode|contrastThreshold|tonalOffset)/));
}
const Pa = (e) => [...[...Array(25)].map((r, t) => `--${e ? `${e}-` : ""}overlays-${t}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], Ia = (e) => (r, t) => {
  const n = e.rootSelector || ":root", o = e.colorSchemeSelector;
  let i = o;
  if (o === "class" && (i = ".%s"), o === "data" && (i = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (i = `[${o}="%s"]`), e.defaultColorScheme === r) {
    if (r === "dark") {
      const s = {};
      return Pa(e.cssVarPrefix).forEach((c) => {
        s[c] = t[c], delete t[c];
      }), i === "media" ? {
        [n]: t,
        "@media (prefers-color-scheme: dark)": {
          [n]: s
        }
      } : i ? {
        [i.replace("%s", r)]: s,
        [`${n}, ${i.replace("%s", r)}`]: t
      } : {
        [n]: {
          ...t,
          ...s
        }
      };
    }
    if (i && i !== "media")
      return `${n}, ${i.replace("%s", String(r))}`;
  } else if (r) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(r)})`]: {
          [n]: t
        }
      };
    if (i)
      return i.replace("%s", String(r));
  }
  return n;
};
function ja(e, r) {
  r.forEach((t) => {
    e[t] || (e[t] = {});
  });
}
function p(e, r, t) {
  !e[r] && t && (e[r] = t);
}
function rr(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : En(e);
}
function Re(e, r) {
  `${r}Channel` in e || (e[`${r}Channel`] = er(rr(e[r]), `MUI: Can't create \`palette.${r}Channel\` because \`palette.${r}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${r}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function Ma(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Te = (e) => {
  try {
    return e();
  } catch {
  }
}, Na = (e = "mui") => ra(e);
function qr(e, r, t, n) {
  if (!r)
    return;
  r = r === !0 ? {} : r;
  const o = n === "dark" ? "dark" : "light";
  if (!t) {
    e[n] = ka({
      ...r,
      palette: {
        mode: o,
        ...r == null ? void 0 : r.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...s
  } = Gr({
    ...t,
    palette: {
      mode: o,
      ...r == null ? void 0 : r.palette
    }
  });
  return e[n] = {
    ...r,
    palette: i,
    opacity: {
      ...On(o),
      ...r == null ? void 0 : r.opacity
    },
    overlays: (r == null ? void 0 : r.overlays) || Rn(o)
  }, s;
}
function Da(e = {}, ...r) {
  const {
    colorSchemes: t = {
      light: !0
    },
    defaultColorScheme: n,
    disableCssColorScheme: o = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: s = Aa,
    colorSchemeSelector: c = t.light && t.dark ? "media" : void 0,
    rootSelector: f = ":root",
    ...d
  } = e, h = Object.keys(t)[0], m = n || (t.light && h !== "light" ? "light" : h), g = Na(i), {
    [m]: C,
    light: v,
    dark: u,
    ...R
  } = t, k = {
    ...R
  };
  let F = C;
  if ((m === "dark" && !("dark" in t) || m === "light" && !("light" in t)) && (F = !0), !F)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${m}\` option is either missing or invalid.` : Me(21, m));
  const E = qr(k, F, d, m);
  v && !k.light && qr(k, v, void 0, "light"), u && !k.dark && qr(k, u, void 0, "dark");
  let T = {
    defaultColorScheme: m,
    ...E,
    cssVarPrefix: i,
    colorSchemeSelector: c,
    rootSelector: f,
    getCssVar: g,
    colorSchemes: k,
    font: {
      ...ma(E.typography),
      ...E.font
    },
    spacing: Ma(d.spacing)
  };
  Object.keys(T.colorSchemes).forEach((me) => {
    const a = T.colorSchemes[me].palette, $ = (I) => {
      const U = I.split("-"), K = U[1], fe = U[2];
      return g(I, a[K][fe]);
    };
    if (a.mode === "light" && (p(a.common, "background", "#fff"), p(a.common, "onBackground", "#000")), a.mode === "dark" && (p(a.common, "background", "#000"), p(a.common, "onBackground", "#fff")), ja(a, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), a.mode === "light") {
      p(a.Alert, "errorColor", re(a.error.light, 0.6)), p(a.Alert, "infoColor", re(a.info.light, 0.6)), p(a.Alert, "successColor", re(a.success.light, 0.6)), p(a.Alert, "warningColor", re(a.warning.light, 0.6)), p(a.Alert, "errorFilledBg", $("palette-error-main")), p(a.Alert, "infoFilledBg", $("palette-info-main")), p(a.Alert, "successFilledBg", $("palette-success-main")), p(a.Alert, "warningFilledBg", $("palette-warning-main")), p(a.Alert, "errorFilledColor", Te(() => a.getContrastText(a.error.main))), p(a.Alert, "infoFilledColor", Te(() => a.getContrastText(a.info.main))), p(a.Alert, "successFilledColor", Te(() => a.getContrastText(a.success.main))), p(a.Alert, "warningFilledColor", Te(() => a.getContrastText(a.warning.main))), p(a.Alert, "errorStandardBg", te(a.error.light, 0.9)), p(a.Alert, "infoStandardBg", te(a.info.light, 0.9)), p(a.Alert, "successStandardBg", te(a.success.light, 0.9)), p(a.Alert, "warningStandardBg", te(a.warning.light, 0.9)), p(a.Alert, "errorIconColor", $("palette-error-main")), p(a.Alert, "infoIconColor", $("palette-info-main")), p(a.Alert, "successIconColor", $("palette-success-main")), p(a.Alert, "warningIconColor", $("palette-warning-main")), p(a.AppBar, "defaultBg", $("palette-grey-100")), p(a.Avatar, "defaultBg", $("palette-grey-400")), p(a.Button, "inheritContainedBg", $("palette-grey-300")), p(a.Button, "inheritContainedHoverBg", $("palette-grey-A100")), p(a.Chip, "defaultBorder", $("palette-grey-400")), p(a.Chip, "defaultAvatarColor", $("palette-grey-700")), p(a.Chip, "defaultIconColor", $("palette-grey-700")), p(a.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), p(a.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), p(a.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), p(a.LinearProgress, "primaryBg", te(a.primary.main, 0.62)), p(a.LinearProgress, "secondaryBg", te(a.secondary.main, 0.62)), p(a.LinearProgress, "errorBg", te(a.error.main, 0.62)), p(a.LinearProgress, "infoBg", te(a.info.main, 0.62)), p(a.LinearProgress, "successBg", te(a.success.main, 0.62)), p(a.LinearProgress, "warningBg", te(a.warning.main, 0.62)), p(a.Skeleton, "bg", `rgba(${$("palette-text-primaryChannel")} / 0.11)`), p(a.Slider, "primaryTrack", te(a.primary.main, 0.62)), p(a.Slider, "secondaryTrack", te(a.secondary.main, 0.62)), p(a.Slider, "errorTrack", te(a.error.main, 0.62)), p(a.Slider, "infoTrack", te(a.info.main, 0.62)), p(a.Slider, "successTrack", te(a.success.main, 0.62)), p(a.Slider, "warningTrack", te(a.warning.main, 0.62));
      const I = dr(a.background.default, 0.8);
      p(a.SnackbarContent, "bg", I), p(a.SnackbarContent, "color", Te(() => a.getContrastText(I))), p(a.SpeedDialAction, "fabHoverBg", dr(a.background.paper, 0.15)), p(a.StepConnector, "border", $("palette-grey-400")), p(a.StepContent, "border", $("palette-grey-400")), p(a.Switch, "defaultColor", $("palette-common-white")), p(a.Switch, "defaultDisabledColor", $("palette-grey-100")), p(a.Switch, "primaryDisabledColor", te(a.primary.main, 0.62)), p(a.Switch, "secondaryDisabledColor", te(a.secondary.main, 0.62)), p(a.Switch, "errorDisabledColor", te(a.error.main, 0.62)), p(a.Switch, "infoDisabledColor", te(a.info.main, 0.62)), p(a.Switch, "successDisabledColor", te(a.success.main, 0.62)), p(a.Switch, "warningDisabledColor", te(a.warning.main, 0.62)), p(a.TableCell, "border", te(fr(a.divider, 1), 0.88)), p(a.Tooltip, "bg", fr(a.grey[700], 0.92));
    }
    if (a.mode === "dark") {
      p(a.Alert, "errorColor", te(a.error.light, 0.6)), p(a.Alert, "infoColor", te(a.info.light, 0.6)), p(a.Alert, "successColor", te(a.success.light, 0.6)), p(a.Alert, "warningColor", te(a.warning.light, 0.6)), p(a.Alert, "errorFilledBg", $("palette-error-dark")), p(a.Alert, "infoFilledBg", $("palette-info-dark")), p(a.Alert, "successFilledBg", $("palette-success-dark")), p(a.Alert, "warningFilledBg", $("palette-warning-dark")), p(a.Alert, "errorFilledColor", Te(() => a.getContrastText(a.error.dark))), p(a.Alert, "infoFilledColor", Te(() => a.getContrastText(a.info.dark))), p(a.Alert, "successFilledColor", Te(() => a.getContrastText(a.success.dark))), p(a.Alert, "warningFilledColor", Te(() => a.getContrastText(a.warning.dark))), p(a.Alert, "errorStandardBg", re(a.error.light, 0.9)), p(a.Alert, "infoStandardBg", re(a.info.light, 0.9)), p(a.Alert, "successStandardBg", re(a.success.light, 0.9)), p(a.Alert, "warningStandardBg", re(a.warning.light, 0.9)), p(a.Alert, "errorIconColor", $("palette-error-main")), p(a.Alert, "infoIconColor", $("palette-info-main")), p(a.Alert, "successIconColor", $("palette-success-main")), p(a.Alert, "warningIconColor", $("palette-warning-main")), p(a.AppBar, "defaultBg", $("palette-grey-900")), p(a.AppBar, "darkBg", $("palette-background-paper")), p(a.AppBar, "darkColor", $("palette-text-primary")), p(a.Avatar, "defaultBg", $("palette-grey-600")), p(a.Button, "inheritContainedBg", $("palette-grey-800")), p(a.Button, "inheritContainedHoverBg", $("palette-grey-700")), p(a.Chip, "defaultBorder", $("palette-grey-700")), p(a.Chip, "defaultAvatarColor", $("palette-grey-300")), p(a.Chip, "defaultIconColor", $("palette-grey-300")), p(a.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), p(a.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), p(a.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), p(a.LinearProgress, "primaryBg", re(a.primary.main, 0.5)), p(a.LinearProgress, "secondaryBg", re(a.secondary.main, 0.5)), p(a.LinearProgress, "errorBg", re(a.error.main, 0.5)), p(a.LinearProgress, "infoBg", re(a.info.main, 0.5)), p(a.LinearProgress, "successBg", re(a.success.main, 0.5)), p(a.LinearProgress, "warningBg", re(a.warning.main, 0.5)), p(a.Skeleton, "bg", `rgba(${$("palette-text-primaryChannel")} / 0.13)`), p(a.Slider, "primaryTrack", re(a.primary.main, 0.5)), p(a.Slider, "secondaryTrack", re(a.secondary.main, 0.5)), p(a.Slider, "errorTrack", re(a.error.main, 0.5)), p(a.Slider, "infoTrack", re(a.info.main, 0.5)), p(a.Slider, "successTrack", re(a.success.main, 0.5)), p(a.Slider, "warningTrack", re(a.warning.main, 0.5));
      const I = dr(a.background.default, 0.98);
      p(a.SnackbarContent, "bg", I), p(a.SnackbarContent, "color", Te(() => a.getContrastText(I))), p(a.SpeedDialAction, "fabHoverBg", dr(a.background.paper, 0.15)), p(a.StepConnector, "border", $("palette-grey-600")), p(a.StepContent, "border", $("palette-grey-600")), p(a.Switch, "defaultColor", $("palette-grey-300")), p(a.Switch, "defaultDisabledColor", $("palette-grey-600")), p(a.Switch, "primaryDisabledColor", re(a.primary.main, 0.55)), p(a.Switch, "secondaryDisabledColor", re(a.secondary.main, 0.55)), p(a.Switch, "errorDisabledColor", re(a.error.main, 0.55)), p(a.Switch, "infoDisabledColor", re(a.info.main, 0.55)), p(a.Switch, "successDisabledColor", re(a.success.main, 0.55)), p(a.Switch, "warningDisabledColor", re(a.warning.main, 0.55)), p(a.TableCell, "border", re(fr(a.divider, 1), 0.68)), p(a.Tooltip, "bg", fr(a.grey[700], 0.92));
    }
    Re(a.background, "default"), Re(a.background, "paper"), Re(a.common, "background"), Re(a.common, "onBackground"), Re(a, "divider"), Object.keys(a).forEach((I) => {
      const U = a[I];
      I !== "tonalOffset" && U && typeof U == "object" && (U.main && p(a[I], "mainChannel", er(rr(U.main))), U.light && p(a[I], "lightChannel", er(rr(U.light))), U.dark && p(a[I], "darkChannel", er(rr(U.dark))), U.contrastText && p(a[I], "contrastTextChannel", er(rr(U.contrastText))), I === "text" && (Re(a[I], "primary"), Re(a[I], "secondary")), I === "action" && (U.active && Re(a[I], "active"), U.selected && Re(a[I], "selected")));
    });
  }), T = r.reduce((me, a) => Se(me, a), T);
  const y = {
    prefix: i,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: s,
    getSelector: Ia(T)
  }, {
    vars: G,
    generateThemeVars: ne,
    generateStyleSheets: Z
  } = oa(T, y);
  return T.vars = G, Object.entries(T.colorSchemes[T.defaultColorScheme]).forEach(([me, a]) => {
    T[me] = a;
  }), T.generateThemeVars = ne, T.generateStyleSheets = Z, T.generateSpacing = function() {
    return yn(d.spacing, nt(this));
  }, T.getColorSchemeSelector = ia(c), T.spacing = T.generateSpacing(), T.shouldSkipGeneratingVar = s, T.unstable_sxConfig = {
    ...Rr,
    ...d == null ? void 0 : d.unstable_sxConfig
  }, T.unstable_sx = function(a) {
    return Qe({
      sx: a,
      theme: this
    });
  }, T.toRuntimeSource = _n, T;
}
function nn(e, r, t) {
  e.colorSchemes && t && (e.colorSchemes[r] = {
    ...t !== !0 && t,
    palette: ut({
      ...t === !0 ? {} : t.palette,
      mode: r
    })
    // cast type to skip module augmentation test
  });
}
function Ba(e = {}, ...r) {
  const {
    palette: t,
    cssVariables: n = !1,
    colorSchemes: o = t ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = t == null ? void 0 : t.mode,
    ...s
  } = e, c = i || "light", f = o == null ? void 0 : o[c], d = {
    ...o,
    ...t ? {
      [c]: {
        ...typeof f != "boolean" && f,
        palette: t
      }
    } : void 0
  };
  if (n === !1) {
    if (!("colorSchemes" in e))
      return Gr(e, ...r);
    let h = t;
    "palette" in e || d[c] && (d[c] !== !0 ? h = d[c].palette : c === "dark" && (h = {
      mode: "dark"
    }));
    const m = Gr({
      ...e,
      palette: h
    }, ...r);
    return m.defaultColorScheme = c, m.colorSchemes = d, m.palette.mode === "light" && (m.colorSchemes.light = {
      ...d.light !== !0 && d.light,
      palette: m.palette
    }, nn(m, "dark", d.dark)), m.palette.mode === "dark" && (m.colorSchemes.dark = {
      ...d.dark !== !0 && d.dark,
      palette: m.palette
    }, nn(m, "light", d.light)), m;
  }
  return !t && !("light" in d) && c === "light" && (d.light = !0), Da({
    ...s,
    colorSchemes: d,
    defaultColorScheme: c,
    ...typeof n != "boolean" && n
  }, ...r);
}
const $n = Ba();
function Fa() {
  const e = $i($n);
  return process.env.NODE_ENV !== "production" && Ve.useDebugValue(e), e[pn] || e;
}
function Va(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const La = (e) => Va(e) && e !== "classes", ue = Fi({
  themeId: pn,
  defaultTheme: $n,
  rootShouldForwardProp: La
}), kn = ea;
process.env.NODE_ENV !== "production" && (b.node, b.object.isRequired);
function Wa(e) {
  return Xi(e);
}
function qa(e) {
  return typeof e.main == "string";
}
function Ua(e, r = []) {
  if (!qa(e))
    return !1;
  for (const t of r)
    if (!e.hasOwnProperty(t) || typeof e[t] != "string")
      return !1;
  return !0;
}
function Ya(e = []) {
  return ([, r]) => r && Ua(r, e);
}
function za(e) {
  return at("MuiCircularProgress", e);
}
ji("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const Ie = 44, Zr = un`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, Kr = un`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, Ga = typeof Zr != "string" ? ln`
        animation: ${Zr} 1.4s linear infinite;
      ` : null, Za = typeof Kr != "string" ? ln`
        animation: ${Kr} 1.4s ease-in-out infinite;
      ` : null, Ka = (e) => {
  const {
    classes: r,
    variant: t,
    color: n,
    disableShrink: o
  } = e, i = {
    root: ["root", t, `color${Fe(n)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Fe(t)}`, o && "circleDisableShrink"]
  };
  return Hi(i, za, r);
}, Ha = ue("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, r[t.variant], r[`color${Fe(t.color)}`]];
  }
})(kn(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: Ga || {
      animation: `${Zr} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(Ya()).map(([r]) => ({
    props: {
      color: r
    },
    style: {
      color: (e.vars || e).palette[r].main
    }
  }))]
}))), Ja = ue("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, r) => r.svg
})({
  display: "block"
  // Keeps the progress centered
}), Qa = ue("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.circle, r[`circle${Fe(t.variant)}`], t.disableShrink && r.circleDisableShrink];
  }
})(kn(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: r
    }) => r.variant === "indeterminate" && !r.disableShrink,
    style: Za || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${Kr} 1.4s ease-in-out infinite`
    }
  }]
}))), An = /* @__PURE__ */ Ve.forwardRef(function(r, t) {
  const n = Wa({
    props: r,
    name: "MuiCircularProgress"
  }), {
    className: o,
    color: i = "primary",
    disableShrink: s = !1,
    size: c = 40,
    style: f,
    thickness: d = 3.6,
    value: h = 0,
    variant: m = "indeterminate",
    ...g
  } = n, C = {
    ...n,
    color: i,
    disableShrink: s,
    size: c,
    thickness: d,
    value: h,
    variant: m
  }, v = Ka(C), u = {}, R = {}, k = {};
  if (m === "determinate") {
    const F = 2 * Math.PI * ((Ie - d) / 2);
    u.strokeDasharray = F.toFixed(3), k["aria-valuenow"] = Math.round(h), u.strokeDashoffset = `${((100 - h) / 100 * F).toFixed(3)}px`, R.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ A.jsx(Ha, {
    className: Pi(v.root, o),
    style: {
      width: c,
      height: c,
      ...R,
      ...f
    },
    ownerState: C,
    ref: t,
    role: "progressbar",
    ...k,
    ...g,
    children: /* @__PURE__ */ A.jsx(Ja, {
      className: v.svg,
      ownerState: C,
      viewBox: `${Ie / 2} ${Ie / 2} ${Ie} ${Ie}`,
      children: /* @__PURE__ */ A.jsx(Qa, {
        className: v.circle,
        style: u,
        ownerState: C,
        cx: Ie,
        cy: Ie,
        r: (Ie - d) / 2,
        fill: "none",
        strokeWidth: d
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (An.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: b.oneOfType([b.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: Ki(b.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: b.oneOfType([b.number, b.string]),
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: b.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: b.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: b.oneOf(["determinate", "indeterminate"])
});
const Xa = ue(Qr, {
  name: "FormButton",
  overridesResolver: (e, r) => [r.root]
})(({ theme: e }) => ({
  color: e.palette.formButton.fontColor,
  background: e.palette.formButton.backgroundColor,
  fontSize: e.palette.formButton.fontSize
})), es = ue(An, {
  name: "FormButton",
  overridesResolver: (e, r) => [r.spinner]
})(({ theme: e }) => ({
  color: e.palette.formButton.spinnerColor
})), rs = ({
  text: e,
  loading: r,
  children: t,
  variant: n = "contained",
  ...o
}) => /* @__PURE__ */ A.jsx(
  Xa,
  {
    variant: n,
    endIcon: r && /* @__PURE__ */ A.jsx(es, { size: 24 }),
    ...o,
    children: t || e
  }
);
rs.propTypes = {
  /**
   * Refers to specific style for the section
   */
  section: b.oneOf([
    "feedback",
    "profile",
    "emailShare",
    "loginWithEmailAndPass",
    "loginWithEmail",
    "registration",
    "unsubscribe"
  ]),
  /**
   * MUI button variant, defaults to contained
   */
  variant: b.string,
  /**
   * Button type, defaults to "button"
   */
  type: b.oneOf(["button", "submit"]),
  /**
   * Button text
   */
  text: b.string,
  /**
   * Show the loading spinner
   */
  loading: b.bool,
  /**
   * Disable the button
   */
  disabled: b.bool,
  /**
   * Support for child component
   */
  children: b.string
};
const ts = ue(Ae, {
  shouldForwardProp: (e) => ke(e) && e !== "textFont"
})(({ theme: e }) => ({
  ...e.typography.h5,
  fontWeight: "bold",
  textAlign: "center",
  marginBottom: "16px"
})), Ur = ue(Ae, {
  shouldForwardProp: (e) => ke(e) && e !== "textFont"
})(({ theme: e, textFont: r }) => ({
  color: e.palette.text.primary,
  fontSize: e.typography.body2.fontSize,
  fontFamily: r
})), Pn = ({
  title: e,
  subtitle: r,
  options: t,
  textFont: n,
  goBackText: o,
  goBackTextColor: i,
  onGoBack: s,
  onConfirm: c,
  buttonLabel: f,
  buttonColor: d
}) => {
  const h = cn(), m = Xr(h.breakpoints.down("sm")), g = t.filter((u) => !u.isSubscribed), C = t.filter((u) => u.isSubscribed), v = (u, R) => R.length > 0 && /* @__PURE__ */ A.jsxs(
    ye,
    {
      sx: {
        width: m ? "100%" : "70%",
        ml: "auto",
        mr: "auto",
        textAlign: "left"
      },
      children: [
        /* @__PURE__ */ A.jsx(Ur, { variant: "body2", textFont: n, children: u }),
        /* @__PURE__ */ A.jsx(
          "ul",
          {
            style: {
              paddingLeft: "56px",
              display: "flex",
              flexDirection: "column",
              gap: "10px"
            },
            children: R.map((k) => /* @__PURE__ */ A.jsx("li", { children: /* @__PURE__ */ A.jsx(Ur, { variant: "body2", textFont: n, children: k.label }) }, `option-${k.label}`))
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ A.jsxs(
    ye,
    {
      sx: {
        maxWidth: "720px",
        mx: "auto",
        px: "16px",
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ A.jsx(ts, { component: "h2", textFont: n, children: e }),
        /* @__PURE__ */ A.jsx(
          ye,
          {
            sx: {
              width: m ? "100%" : "90%",
              mx: "auto",
              textAlign: "center",
              mb: "24px"
            },
            children: /* @__PURE__ */ A.jsxs(Ur, { variant: "body2", textFont: n, children: [
              r,
              /* @__PURE__ */ A.jsx(
                et,
                {
                  component: "button",
                  underline: "none",
                  onClick: s,
                  sx: { color: i, mb: "2px", ml: "4px" },
                  children: o
                }
              ),
              "."
            ] })
          }
        ),
        v("Unsubscribe from the following:", g),
        v("Subscribe to the following:", C),
        /* @__PURE__ */ A.jsx(
          Qr,
          {
            variant: "contained",
            color: d,
            sx: { mt: "20px", fontWeight: "bold", px: "32px" },
            onClick: c,
            children: f
          }
        )
      ]
    }
  );
};
Pn.propTypes = {
  /**
   * The main title of the component.
   */
  title: b.string,
  /**
   * The subtitle displayed below the main title.
   */
  subtitle: b.string,
  /**
   * List of options selected by the user, categorized as either subscribed or unsubscribed.
   * Each option object must include `label`, `campaignId`, `brandId`, `siteId`, and `isSubscribed`.
   */
  options: b.arrayOf(
    b.shape({
      label: b.string.isRequired,
      campaignId: b.number.isRequired,
      brandId: b.number.isRequired,
      siteId: b.number.isRequired,
      isSubscribed: b.bool.isRequired
    })
  ).isRequired,
  /**
   * Font family used for text elements.
   */
  textFont: b.string,
  /**
   * Text for the back navigation (e.g., 'click here').
   */
  goBackText: b.string,
  /**
   * Color of the `goBackText`
   */
  goBackTextColor: b.string,
  /**
   * Callback function triggered when the user clicks the `goBackText`.
   */
  onGoBack: b.func,
  /**
   * Callback function triggered when the user clicks the confirm button.
   */
  onConfirm: b.func,
  /**
   * Label text displayed inside the confirm button.
   */
  buttonLabel: b.string,
  /**
   * Color of the confirm button. Should match a color key from the MUI theme (e.g., 'primary', 'secondary').
   */
  buttonColor: b.string
};
Pn.defaultProps = {
  buttonLabel: "CONFIRM",
  buttonColor: "primary"
};
const pr = ue(Ae, {
  shouldForwardProp: (e) => ke(e) && e !== "textFont"
})(({ theme: e }) => ({
  color: e.palette.text.primary,
  fontSize: e.typography.body2.fontSize
})), ns = ue(Ae, {
  shouldForwardProp: (e) => ke(e) && e !== "textFont"
})(({ theme: e }) => ({
  ...e.typography.h5,
  fontWeight: "bold",
  textAlign: "center",
  marginBottom: "16px"
})), In = ({
  title: e,
  subtitle: r,
  infoText: t,
  linkText: n,
  linkColor: o,
  linkHref: i,
  textFont: s,
  options: c,
  checkboxCheckedColor: f,
  onContinue: d,
  buttonLabel: h,
  buttonColor: m
}) => {
  const g = cn(), C = Xr(g.breakpoints.down("sm")), [v, u] = Xn(c), R = (F) => {
    const E = v.map(
      (T) => T === F ? { ...T, isSubscribed: !T.isSubscribed } : T
    );
    u(E);
  }, k = () => {
    if (!n || !i || !r.includes(n))
      return /* @__PURE__ */ A.jsx(pr, { variant: "body2", children: r });
    const F = r.split(n);
    return /* @__PURE__ */ A.jsx(pr, { variant: "body2", component: "span", children: F.map((E, T) => /* @__PURE__ */ A.jsxs(br.Fragment, { children: [
      E,
      T < F.length - 1 && /* @__PURE__ */ A.jsx(et, { href: i, underline: "hover", sx: { color: o }, children: n })
    ] }, `link-${T}-${E}`)) });
  };
  return /* @__PURE__ */ A.jsxs(
    ye,
    {
      sx: {
        maxWidth: "720px",
        mx: "auto",
        px: "16px",
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ A.jsx(ns, { component: "h2", textFont: s, children: e }),
        /* @__PURE__ */ A.jsxs(
          ye,
          {
            sx: { width: C ? "100%" : "80%", mx: "auto", textAlign: "left" },
            children: [
              k(),
              /* @__PURE__ */ A.jsx(pr, { variant: "body2", textFont: s, sx: { mt: 2 }, children: t })
            ]
          }
        ),
        /* @__PURE__ */ A.jsx(
          ye,
          {
            sx: {
              width: C ? "100%" : "70%",
              mx: "auto",
              mt: "16px",
              textAlign: "left"
            },
            children: v.map((F) => /* @__PURE__ */ A.jsx(
              eo,
              {
                control: /* @__PURE__ */ A.jsx(
                  ro,
                  {
                    checked: F.isSubscribed,
                    onChange: () => R(F),
                    sx: f ? {
                      "&.Mui-checked": {
                        color: f
                      }
                    } : {}
                  }
                ),
                label: /* @__PURE__ */ A.jsx(pr, { variant: "body2", textFont: s, children: F.label }),
                sx: { alignItems: "center", mb: "8px", fontFamily: s }
              },
              `option-${F.label}`
            ))
          }
        ),
        /* @__PURE__ */ A.jsx(
          Qr,
          {
            variant: "contained",
            color: m,
            sx: { mt: "20px", fontWeight: "bold", px: "32px" },
            onClick: () => d ? d(v) : {},
            children: h
          }
        )
      ]
    }
  );
};
In.propTypes = {
  /**
   * The main title of the component.
   */
  title: b.string.isRequired,
  /**
   * The subtitle displayed below the main title.
   */
  subtitle: b.string.isRequired,
  /**
   * Informational text displayed in the form.
   */
  infoText: b.string.isRequired,
  /**
   * Text for the link shown in the subtitle.
   */
  linkText: b.string,
  /**
   * Color of the link in the subtitle.
   */
  linkColor: b.string,
  /**
   * URL or href value for the subtitle link.
   */
  linkHref: b.string,
  /**
   * Font family used for text elements.
   */
  textFont: b.string,
  /**
   * List of campaigns available to subscribe or unsubscribe.
   */
  options: b.arrayOf(
    b.shape({
      label: b.string.isRequired,
      campaignId: b.number.isRequired,
      brandId: b.number.isRequired,
      siteId: b.number.isRequired,
      isSubscribed: b.bool.isRequired
    })
  ).isRequired,
  /**
   * Color used when a checkbox is checked.
   */
  checkboxCheckedColor: b.string,
  /**
   * Callback function triggered when the user continues,
   * receiving the updated list of selected options.
   */
  onContinue: b.func,
  /**
   * Text label for the continue button.
   */
  buttonLabel: b.string,
  /**
   * Color of the continue button. Should match a color key from the MUI theme (e.g., 'primary', 'secondary').
   */
  buttonColor: b.string
};
In.defaultProps = {
  buttonLabel: "CONTINUE",
  buttonColor: "primary"
};
const os = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20viewBox='0%200%20285%2026'%3e%3c!--%20Generator:%20Adobe%20Illustrator%2029.5.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%202.1.0%20Build%20141)%20--%3e%3cdefs%3e%3cstyle%3e%20.st0%20{%20fill:%20%23f36e4e;%20}%20.st1%20{%20fill:%20%23fff;%20}%20%3c/style%3e%3c/defs%3e%3cpath%20class='st1'%20d='M3.33,24.41H.16V1.77h14.14v2.78H3.33v7.04h10.27v2.72H3.33v10.11Z'/%3e%3cpath%20class='st1'%20d='M22.1,3.78c.01.52-.2,1.02-.59,1.38-.38.36-.89.55-1.41.54-.52.01-1.03-.19-1.4-.56-.37-.35-.58-.85-.57-1.36-.01-.52.19-1.03.57-1.39.37-.37.87-.57,1.4-.56.53,0,1.03.19,1.41.56.38.36.6.86.59,1.39ZM21.62,24.41h-3.01v-15.16h3.01v15.16Z'/%3e%3cpath%20class='st1'%20d='M27.21,10.95c-.02-.64-.05-1.2-.1-1.7h2.85c.04.38.07.83.1,1.33.02.5.03.91.03,1.23h.1c.41-.88,1.06-1.63,1.87-2.16.82-.54,1.78-.83,2.77-.82.4,0,.8.04,1.18.13l-.13,2.78c-.45-.11-.91-.16-1.37-.16-.65-.02-1.3.12-1.89.4-.52.25-.97.62-1.33,1.07-.36.46-.63.99-.78,1.55-.17.6-.26,1.22-.26,1.84v7.97h-3.01v-11.9c0-.4-.01-.93-.03-1.57Z'/%3e%3cpath%20class='st1'%20d='M48.09,13.09c-.36-.57-.85-1.04-1.44-1.36-.63-.36-1.35-.54-2.08-.53-.34,0-.69.04-1.02.11-.32.07-.63.19-.91.35-.26.15-.48.36-.64.61-.17.27-.25.59-.24.91-.02.6.32,1.16.86,1.42.82.39,1.69.68,2.59.85.68.16,1.36.36,2.01.61.58.21,1.12.51,1.61.88.45.34.81.77,1.07,1.26.27.54.4,1.13.38,1.73.02.79-.15,1.57-.51,2.27-.33.6-.79,1.12-1.36,1.52-.59.4-1.24.69-1.94.85-.73.17-1.49.26-2.24.26-1.16,0-2.3-.23-3.37-.67-1.08-.43-2.02-1.14-2.74-2.05l2.14-1.82c.44.62,1.01,1.14,1.68,1.5.72.41,1.53.61,2.35.61.37,0,.74-.04,1.1-.11.34-.07.66-.19.96-.37.62-.35.98-1.02.94-1.73.02-.68-.38-1.3-1.01-1.57-.95-.43-1.94-.75-2.96-.96-.51-.13-1.03-.28-1.55-.46-.51-.18-.99-.43-1.42-.75-.43-.32-.78-.73-1.04-1.2-.28-.55-.42-1.16-.4-1.77-.02-.73.15-1.45.5-2.1.32-.57.76-1.06,1.29-1.44.55-.38,1.17-.66,1.82-.83.69-.18,1.4-.27,2.11-.27,1.08,0,2.15.22,3.15.64.95.38,1.77,1.02,2.35,1.86l-2.08,1.76Z'/%3e%3cpath%20class='st1'%20d='M62.93,11.71h-4.03v7.88c-.06.69.12,1.39.51,1.96.43.43,1.03.64,1.63.59.3,0,.6-.03.89-.09.3-.05.59-.14.86-.26l.1,2.46c-.39.13-.79.24-1.2.3-.45.08-.9.11-1.36.11-1.21.08-2.4-.35-3.28-1.18-.83-.99-1.23-2.26-1.14-3.55v-8.22h-2.91v-2.46h2.91v-4.35h2.98v4.35h4.03v2.46Z'/%3e%3cpath%20class='st1'%20d='M72.88,19.81h.06l5.31-18.04h3.49l5.28,18.04h.06l4.99-18.04h3.36l-6.65,22.65h-3.3l-5.5-18.2h-.06l-5.5,18.2h-3.29l-6.65-22.65h3.42l4.99,18.04Z'/%3e%3cpath%20class='st1'%20d='M113.22,16.8c.01,1.11-.2,2.21-.62,3.23-.4.96-.99,1.82-1.73,2.54-.75.72-1.64,1.29-2.61,1.66-2.08.79-4.38.79-6.46,0-.97-.37-1.85-.94-2.59-1.66-.73-.73-1.31-1.59-1.71-2.54-.42-1.02-.64-2.12-.62-3.23-.01-1.1.2-2.2.62-3.21.8-1.92,2.36-3.42,4.3-4.16,2.08-.79,4.38-.79,6.46,0,.97.37,1.85.93,2.61,1.65.74.71,1.33,1.57,1.73,2.51.42,1.02.64,2.11.62,3.21ZM110.09,16.82c0-.7-.11-1.4-.34-2.07-.21-.64-.54-1.23-.98-1.74-.44-.51-.98-.92-1.59-1.2-1.38-.6-2.95-.6-4.33,0-.61.28-1.15.69-1.59,1.2-.43.51-.77,1.1-.98,1.74-.45,1.35-.45,2.8,0,4.14.21.64.55,1.24.98,1.76.43.51.98.93,1.59,1.21,1.38.59,2.95.59,4.33,0,.61-.28,1.15-.7,1.59-1.21.43-.52.76-1.11.98-1.76.23-.67.34-1.37.34-2.07h0Z'/%3e%3cpath%20class='st1'%20d='M117.79,10.95c-.02-.64-.05-1.2-.1-1.7h2.85c.04.38.07.83.1,1.33.02.5.03.91.03,1.23h.1c.41-.88,1.06-1.63,1.87-2.16.82-.54,1.78-.83,2.77-.82.4,0,.8.04,1.18.13l-.13,2.78c-.45-.11-.91-.16-1.37-.16-.65-.02-1.3.12-1.89.4-.52.25-.97.62-1.33,1.07-.36.46-.63.99-.78,1.55-.17.6-.26,1.22-.26,1.84v7.97h-3.01v-11.9c0-.4-.01-.93-.03-1.57Z'/%3e%3cpath%20class='st1'%20d='M142.05,22.01c-.57.91-1.38,1.64-2.35,2.09-.97.48-2.04.72-3.12.72-1.09.02-2.17-.2-3.17-.62-.91-.4-1.73-.98-2.4-1.71-.67-.74-1.2-1.61-1.54-2.56-.37-1-.55-2.07-.54-3.13,0-1.06.18-2.12.54-3.12.34-.94.87-1.81,1.55-2.54.68-.73,1.5-1.31,2.41-1.7.98-.41,2.04-.62,3.1-.61,1.13-.03,2.24.24,3.23.78.86.47,1.6,1.12,2.18,1.9h.06V.23h3.01v24.18h-2.91v-2.4h-.06ZM132.07,16.82c0,.69.11,1.38.32,2.04.2.64.53,1.24.96,1.75.92,1.11,2.3,1.73,3.74,1.69.72,0,1.44-.14,2.09-.45.61-.29,1.16-.69,1.62-1.2.45-.51.8-1.1,1.04-1.74.49-1.34.49-2.81,0-4.15-.24-.64-.59-1.24-1.04-1.75-.45-.51-1-.92-1.62-1.21-.66-.3-1.37-.46-2.09-.45-.75-.02-1.49.14-2.18.45-.6.29-1.14.7-1.57,1.21-.43.52-.76,1.11-.96,1.75-.21.66-.32,1.35-.32,2.04h0Z'/%3e%3cpath%20class='st0'%20d='M174.56,25.19c-1.59.37-3.21.56-4.85.55-1.71.02-3.4-.27-5.01-.86-1.46-.54-2.8-1.36-3.93-2.43-1.11-1.06-1.99-2.34-2.58-3.76-1.24-3.15-1.24-6.66.02-9.8.6-1.42,1.48-2.7,2.61-3.76,1.13-1.05,2.46-1.86,3.9-2.38,1.55-.56,3.18-.85,4.83-.83,1.7-.02,3.38.26,4.99.82,1.39.46,2.66,1.2,3.74,2.19l-3.45,3.93c-.58-.65-1.3-1.17-2.11-1.52-.94-.41-1.95-.61-2.98-.59-.91,0-1.81.17-2.65.53-.8.34-1.51.84-2.11,1.47-.61.65-1.08,1.41-1.39,2.24-.34.91-.51,1.87-.5,2.83-.01.98.14,1.95.45,2.88.28.84.73,1.61,1.33,2.26.61.64,1.35,1.15,2.18,1.47.94.37,1.95.55,2.96.53.61,0,1.22-.05,1.82-.15.55-.09,1.09-.24,1.6-.46v-4.13h-4.32v-4.42h9.34v11.99c-1.23.62-2.54,1.09-3.89,1.41Z'/%3e%3cpath%20class='st0'%20d='M198.34,25.16l-4.92-8.99h-1.86v8.99h-5.34V2.51h8.64c1.07,0,2.14.11,3.18.34.99.21,1.93.59,2.78,1.14.82.53,1.49,1.26,1.97,2.11.52,1.01.77,2.13.74,3.26.05,1.4-.4,2.76-1.25,3.87-.89,1.09-2.1,1.87-3.45,2.24l5.92,9.69h-6.4ZM198.12,9.45c.02-.46-.1-.91-.34-1.29-.22-.33-.52-.59-.87-.77-.37-.19-.78-.31-1.19-.37-.42-.06-.84-.1-1.27-.1h-2.92v5.28h2.6c.46,0,.93-.04,1.38-.11.45-.07.88-.2,1.29-.4.85-.41,1.38-1.29,1.32-2.24h0Z'/%3e%3cpath%20class='st0'%20d='M233.88,13.74c.02,1.68-.29,3.35-.93,4.91-.58,1.43-1.46,2.73-2.57,3.81-1.13,1.07-2.46,1.91-3.92,2.45-3.18,1.15-6.66,1.15-9.84,0-1.45-.54-2.78-1.38-3.9-2.45-1.11-1.08-1.99-2.37-2.58-3.81-.63-1.56-.95-3.23-.93-4.91-.03-1.68.29-3.35.93-4.91.58-1.41,1.46-2.68,2.58-3.73,1.13-1.04,2.46-1.85,3.9-2.37,3.18-1.11,6.65-1.11,9.84,0,1.45.52,2.78,1.32,3.92,2.37,1.11,1.05,1.99,2.32,2.57,3.73.64,1.56.95,3.23.93,4.91ZM228.03,13.74c0-.94-.15-1.87-.48-2.75-.29-.81-.75-1.55-1.33-2.19-.58-.62-1.27-1.1-2.05-1.44-.83-.36-1.73-.54-2.64-.53-1.76-.03-3.46.69-4.67,1.97-.59.63-1.04,1.38-1.33,2.19-.62,1.81-.62,3.78.02,5.58.29.82.74,1.58,1.33,2.22.57.62,1.26,1.12,2.03,1.46,1.68.7,3.57.7,5.24,0,.77-.34,1.47-.84,2.05-1.46.59-.64,1.05-1.4,1.34-2.22.33-.91.49-1.87.48-2.83Z'/%3e%3cpath%20class='st0'%20d='M259.19,20.35c-.44,1.09-1.11,2.07-1.97,2.88-.89.82-1.94,1.46-3.09,1.87-2.61.9-5.44.9-8.04,0-1.13-.41-2.16-1.05-3.04-1.87-.84-.81-1.49-1.79-1.92-2.88-.46-1.19-.69-2.45-.67-3.73V2.51h5.44v13.66c0,.6.08,1.19.24,1.76.15.54.4,1.04.74,1.49.34.45.8.81,1.31,1.04,1.26.51,2.67.51,3.93,0,.52-.24.97-.59,1.33-1.04.34-.44.59-.95.74-1.49.15-.57.23-1.17.22-1.76V2.51h5.47v14.11c.02,1.28-.22,2.54-.69,3.73Z'/%3e%3cpath%20class='st0'%20d='M284.83,9.49c.04,1.16-.22,2.31-.74,3.34-.47.88-1.15,1.64-1.98,2.19-.88.57-1.85.99-2.88,1.22-1.11.26-2.25.39-3.39.38h-2.72v8.54h-5.47V2.51h8.32c1.17,0,2.33.12,3.47.37,1,.21,1.96.62,2.81,1.18.8.54,1.45,1.28,1.89,2.14.49,1.02.73,2.15.69,3.28ZM279.37,9.52c.02-.46-.09-.91-.32-1.31-.21-.34-.51-.62-.86-.8-.39-.2-.8-.33-1.23-.38-.47-.07-.95-.1-1.42-.1h-2.4v5.34h2.3c.49,0,.99-.04,1.47-.13.44-.08.87-.23,1.26-.45.36-.2.66-.49.88-.85.23-.4.34-.86.32-1.33Z'/%3e%3c/svg%3e", Hr = {
  firstWordGroupFooter: os
}, jn = (e) => ![
  "backgroundColor",
  "textColor",
  "borderBottomWidth",
  "borderBottomColor",
  "separatorColor",
  "isMobile"
].includes(e), is = ue(ye, { shouldForwardProp: jn })(
  ({ backgroundColor: e, textColor: r }) => ({
    width: "100%",
    backgroundColor: e,
    color: r,
    padding: "24px 0",
    minHeight: "120px"
  })
), as = ue(ye, { shouldForwardProp: jn })(
  ({ theme: e, isMobile: r, borderBottomWidth: t, borderBottomColor: n }) => ({
    display: "flex",
    justifyContent: r ? "center" : "flex-start",
    alignItems: "center",
    borderBottom: `${t} solid ${n}`,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: "12px",
    [e.breakpoints.down("md")]: {
      justifyContent: "center"
    }
  })
), ss = ue("img")(() => ({
  maxWidth: "200px",
  maxHeight: "60px",
  minHeight: "60px",
  height: "60px",
  width: "200px"
})), cs = ue(ye)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px"
})), ls = ue(ye)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  flexWrap: "wrap",
  gap: "8px",
  [e.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "16px"
  }
})), us = ue(ye)(({ theme: e }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "8px",
  [e.breakpoints.down("md")]: {
    gap: "16px"
  }
})), fs = ue(et)(() => ({
  color: "#FFFFFF",
  textDecoration: "underline",
  fontSize: "0.875rem",
  "&:hover": {
    opacity: 0.8
  }
})), on = ue(Ae, {
  shouldForwardProp: (e) => e !== "separatorColor"
})(({ separatorColor: e }) => ({
  color: e,
  fontSize: "0.875rem"
})), ds = ({
  logo: e,
  footerBackgroundColor: r,
  footerTextColor: t,
  borderBottomWidth: n,
  borderBottomColor: o,
  copyrightText: i,
  addressText: s,
  separatorColor: c,
  links: f
}) => {
  const d = Fa(), h = Xr(d.breakpoints.down("md")), m = !!Hr[e], g = Hr[e];
  return /* @__PURE__ */ A.jsx(
    is,
    {
      backgroundColor: r,
      textColor: t,
      children: /* @__PURE__ */ A.jsxs(cs, { children: [
        m && /* @__PURE__ */ A.jsx(
          as,
          {
            borderBottomWidth: n,
            borderBottomColor: o,
            children: /* @__PURE__ */ A.jsx(ss, { src: g, alt: e })
          }
        ),
        /* @__PURE__ */ A.jsxs(ls, { children: [
          /* @__PURE__ */ A.jsx(Ae, { variant: "body2", children: i }),
          !h && /* @__PURE__ */ A.jsx(on, { separatorColor: c, children: "|" }),
          /* @__PURE__ */ A.jsx(Ae, { variant: "body2", children: s })
        ] }),
        f.length > 0 && /* @__PURE__ */ A.jsx(us, { children: f.map((C, v) => /* @__PURE__ */ A.jsxs(br.Fragment, { children: [
          /* @__PURE__ */ A.jsx(
            fs,
            {
              href: C.href,
              target: "_blank",
              rel: "noopener noreferrer",
              children: C.label
            }
          ),
          v < f.length - 1 && /* @__PURE__ */ A.jsx(on, { separatorColor: c, children: "|" })
        ] }, `link-for-${C.label}`)) })
      ] })
    }
  );
};
ds.propTypes = {
  /**
   * Specifies the logo to be displayed in the footer.
   */
  logo: b.oneOf(Object.keys(Hr)).isRequired,
  /**
   * Sets the font color used in the footer.
   */
  footerTextColor: b.string,
  /**
   * Sets the background color of the footer.
   */
  footerBackgroundColor: b.string,
  /**
   * Defines the bottom border width of the logo container.
   */
  borderBottomWidth: b.string,
  /**
   * Defines the bottom border color of the logo container.
   */
  borderBottomColor: b.string,
  /**
   * Sets the color of the '|' separator character between footer links.
   */
  separatorColor: b.string,
  /**
   * Text to display as the company's copyright.
   */
  copyrightText: b.string,
  /**
   * Text to display as the company's address.
   */
  addressText: b.string,
  /**
   * An array of link objects to display in the footer.
   */
  links: b.arrayOf(
    b.shape({
      label: b.string.isRequired,
      href: b.string.isRequired
    })
  )
};
const ps = "data:image/svg+xml,%3csvg%20id='Layer_1'%20data-name='Layer%201'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20288%2072'%3e%3cdefs%3e%3cstyle%3e.cls-1{fill:%233f5a67;}.cls-2{fill:%23f36e4e;}%3c/style%3e%3c/defs%3e%3ctitle%3eFirstWord_Logo%3c/title%3e%3cpath%20class='cls-1'%20d='M56.58329,45.41084H54.60282V31.25068h8.83984v1.74024H56.58329v4.40039h6.41992v1.69922H56.58329Z'/%3e%3cpath%20class='cls-1'%20d='M68.31961,32.51045a1.12288,1.12288,0,0,1-.36718.86035,1.2545,1.2545,0,0,1-.88282.33984,1.2,1.2,0,0,1-.873-.34961,1.14555,1.14555,0,0,1-.35742-.85058,1.16819,1.16819,0,0,1,.35742-.86914,1.20088,1.20088,0,0,1,.873-.35059,1.23474,1.23474,0,0,1,.88282.35059A1.1551,1.1551,0,0,1,68.31961,32.51045Zm-.30078,12.90039H66.13895V35.93037h1.87988Z'/%3e%3cpath%20class='cls-1'%20d='M71.51786,36.99092c-.0127-.40039-.03321-.75293-.05957-1.06055h1.78027c.02637.24024.0459.51758.05957.83008q.0205.47022.02051.77051h.05957a3.281,3.281,0,0,1,1.16992-1.35059,3.0653,3.0653,0,0,1,1.73047-.50976,2.93694,2.93694,0,0,1,.73926.08007l-.08008,1.74024a3.54538,3.54538,0,0,0-.85938-.09961,2.60329,2.60329,0,0,0-1.17968.25,2.39022,2.39022,0,0,0-.83008.66992,2.81329,2.81329,0,0,0-.49024.96973,4.07055,4.07055,0,0,0-.16015,1.14941v4.98047H71.53836V37.97041Q71.53836,37.591,71.51786,36.99092Z'/%3e%3cpath%20class='cls-1'%20d='M84.5745,38.33076a2.45981,2.45981,0,0,0-.90039-.84961,2.57563,2.57563,0,0,0-1.29981-.33008,3.02539,3.02539,0,0,0-.63965.06934,1.86156,1.86156,0,0,0-.57031.2207,1.21494,1.21494,0,0,0-.40039.37989,1.02647,1.02647,0,0,0-.14941.57031.94781.94781,0,0,0,.54.88965,6.61269,6.61269,0,0,0,1.62011.53027,10.03894,10.03894,0,0,1,1.25977.37988,3.9522,3.9522,0,0,1,1.00976.54981,2.37664,2.37664,0,0,1,.66993.79,2.303,2.303,0,0,1,.24023,1.08007,2.90951,2.90951,0,0,1-.32031,1.41993,2.78332,2.78332,0,0,1-.84961.95019,3.4936,3.4936,0,0,1-1.21.5293,6.056,6.056,0,0,1-1.40039.16016,5.5326,5.5326,0,0,1-2.10938-.41993,4.12111,4.12111,0,0,1-1.71094-1.28027l1.34082-1.13965a3.06914,3.06914,0,0,0,1.04981.94043,2.93057,2.93057,0,0,0,1.46973.37988,3.31059,3.31059,0,0,0,.69043-.07031,1.97672,1.97672,0,0,0,.5996-.22949,1.16326,1.16326,0,0,0,.58985-1.08008,1.0403,1.0403,0,0,0-.62988-.98047,8.48069,8.48069,0,0,0-1.84961-.59961q-.48048-.12012-.97071-.29a3.24509,3.24509,0,0,1-.88965-.4707,2.34332,2.34332,0,0,1-.65039-.75,2.26432,2.26432,0,0,1-.25-1.10937,2.62566,2.62566,0,0,1,.31055-1.31055,2.69847,2.69847,0,0,1,.80957-.89942,3.56211,3.56211,0,0,1,1.14063-.5205,5.11854,5.11854,0,0,1,1.31933-.16992,5.03213,5.03213,0,0,1,1.97071.40039,3.26022,3.26022,0,0,1,1.46972,1.16015Z'/%3e%3cpath%20class='cls-1'%20d='M93.85379,37.47041H91.33426v4.92578a1.86872,1.86872,0,0,0,.31934,1.22559,1.28342,1.28342,0,0,0,1.02051.36914,3.1567,3.1567,0,0,0,.55957-.05469,2.30374,2.30374,0,0,0,.54-.165l.06054,1.54a4.6199,4.6199,0,0,1-.75.18945,5.02368,5.02368,0,0,1-.85058.07032,2.70958,2.70958,0,0,1-2.04981-.74024,3.09269,3.09269,0,0,1-.71-2.21973V37.47041H87.6536v-1.54h1.82031V33.21064h1.86035v2.71973h2.51953Z'/%3e%3cpath%20class='cls-1'%20d='M100.0745,42.531h.04l3.32031-11.28028h2.17969l3.2998,11.28028h.04l3.12012-11.28028h2.09961l-4.15918,14.16016h-2.06055L104.51493,34.031h-.04l-3.44043,11.37988H98.97489L94.81473,31.25068h2.13965Z'/%3e%3cpath%20class='cls-1'%20d='M125.29813,40.65107a5.12464,5.12464,0,0,1-.38965,2.01954,4.79452,4.79452,0,0,1-1.08008,1.58984,4.86106,4.86106,0,0,1-1.62988,1.04,5.69744,5.69744,0,0,1-4.04,0,4.7428,4.7428,0,0,1-1.62012-1.04,4.88919,4.88919,0,0,1-1.07031-1.58984,5.12481,5.12481,0,0,1-.38965-2.01954,5.05262,5.05262,0,0,1,.38965-2.00976,4.736,4.736,0,0,1,2.69043-2.60059,5.69758,5.69758,0,0,1,4.04,0A4.96129,4.96129,0,0,1,123.8284,37.071a4.70284,4.70284,0,0,1,1.08008,1.57031A5.05245,5.05245,0,0,1,125.29813,40.65107Zm-1.96.00977a4.009,4.009,0,0,0-.21-1.2959,3.28172,3.28172,0,0,0-.61231-1.08691,2.94369,2.94369,0,0,0-.99316-.748,3.424,3.424,0,0,0-2.709,0,2.94372,2.94372,0,0,0-.99317.748,3.26242,3.26242,0,0,0-.61133,1.08691,4.0863,4.0863,0,0,0,0,2.5918,3.38246,3.38246,0,0,0,.61133,1.09765,2.89486,2.89486,0,0,0,.99317.75782,3.43508,3.43508,0,0,0,2.709,0,2.89482,2.89482,0,0,0,.99316-.75782,3.403,3.403,0,0,0,.61231-1.09765A4.00469,4.00469,0,0,0,123.33817,40.66084Z'/%3e%3cpath%20class='cls-1'%20d='M128.1536,36.99092c-.0127-.40039-.0332-.75293-.05957-1.06055h1.78027c.02637.24024.0459.51758.05957.83008q.0205.47022.02051.77051h.05957a3.281,3.281,0,0,1,1.16992-1.35059,3.06533,3.06533,0,0,1,1.73047-.50976,2.93694,2.93694,0,0,1,.73926.08007l-.08008,1.74024a3.54529,3.54529,0,0,0-.85937-.09961,2.60333,2.60333,0,0,0-1.17969.25,2.39031,2.39031,0,0,0-.83008.66992,2.81327,2.81327,0,0,0-.49023.96973,4.0702,4.0702,0,0,0-.16016,1.14941v4.98047h-1.87988V37.97041Q128.17411,37.591,128.1536,36.99092Z'/%3e%3cpath%20class='cls-1'%20d='M143.32547,43.91084a3.49138,3.49138,0,0,1-1.46972,1.30957,4.41141,4.41141,0,0,1-1.9502.4502,4.83556,4.83556,0,0,1-1.97949-.38965,4.41547,4.41547,0,0,1-1.5-1.07032,4.81464,4.81464,0,0,1-.96-1.59961,5.58818,5.58818,0,0,1-.33984-1.96,5.5067,5.5067,0,0,1,.33984-1.95019,4.7651,4.7651,0,0,1,.96973-1.58985,4.42921,4.42921,0,0,1,1.50976-1.06054,4.85124,4.85124,0,0,1,1.94043-.37988,4.01688,4.01688,0,0,1,2.01953.49023,4.19081,4.19081,0,0,1,1.36035,1.19043h.04V30.29072h1.87989V45.41084h-1.82032v-1.5Zm-6.23925-3.25a4.13706,4.13706,0,0,0,.19921,1.27637,3.2488,3.2488,0,0,0,.60059,1.09668,2.91921,2.91921,0,0,0,2.33984,1.05664,3.03255,3.03255,0,0,0,1.30957-.27832,3.15663,3.15663,0,0,0,1.01075-.748,3.38533,3.38533,0,0,0,.64941-1.08691,3.76132,3.76132,0,0,0,0-2.59278,3.5075,3.5075,0,0,0-.64941-1.09668,3.09955,3.09955,0,0,0-1.01075-.75781,3.03285,3.03285,0,0,0-1.30957-.2793,3.11223,3.11223,0,0,0-1.36035.2793,2.90875,2.90875,0,0,0-.97949.75781,3.2488,3.2488,0,0,0-.60059,1.09668A4.13706,4.13706,0,0,0,137.08622,40.66084Z'/%3e%3cpath%20class='cls-2'%20d='M163.65018,45.89717a12.74983,12.74983,0,0,1-3.03027.34082,8.803,8.803,0,0,1-3.12989-.54,7.22076,7.22076,0,0,1-2.46-1.52051,6.921,6.921,0,0,1-1.61035-2.34961,8.322,8.322,0,0,1,.00977-6.12988,6.86454,6.86454,0,0,1,1.62988-2.35059,7.22015,7.22015,0,0,1,2.44043-1.48925,8.6088,8.6088,0,0,1,3.02051-.52051,9.284,9.284,0,0,1,3.11914.50976,6.45748,6.45748,0,0,1,2.34082,1.37012l-2.16016,2.46a3.74868,3.74868,0,0,0-1.32031-.95019,4.48688,4.48688,0,0,0-1.86035-.36914,4.12168,4.12168,0,0,0-1.65918.3291,3.99716,3.99716,0,0,0-1.32031.9209,4.16019,4.16019,0,0,0-.87012,1.39941,4.905,4.905,0,0,0-.30957,1.77051,5.54318,5.54318,0,0,0,.2793,1.7998,3.879,3.879,0,0,0,.83007,1.41016,3.7888,3.7888,0,0,0,1.36036.91992,4.87333,4.87333,0,0,0,1.8496.33008,6.87816,6.87816,0,0,0,1.14063-.09082,4.27677,4.27677,0,0,0,1-.28906V40.278H160.24V37.51728h5.83985v7.5A10.87211,10.87211,0,0,1,163.65018,45.89717Z'/%3e%3cpath%20class='cls-2'%20d='M178.52127,45.87764l-3.07421-5.62012h-1.166v5.62012H170.9412V31.71748h5.40039a9.39476,9.39476,0,0,1,1.98925.21,5.19845,5.19845,0,0,1,1.74024.71,3.725,3.725,0,0,1,1.23047,1.32031,4.12293,4.12293,0,0,1,.46,2.04,3.76649,3.76649,0,0,1-.78027,2.41993,4.25534,4.25534,0,0,1-2.16016,1.40039l3.70019,6.05957Zm-.13964-9.82032a1.41351,1.41351,0,0,0-.21192-.80957,1.45,1.45,0,0,0-.542-.48047,2.4036,2.4036,0,0,0-.74414-.22949,5.50268,5.50268,0,0,0-.79395-.06054h-1.82812V37.778h1.62793a5.50163,5.50163,0,0,0,.86426-.07032,2.77284,2.77284,0,0,0,.80371-.25,1.45381,1.45381,0,0,0,.82422-1.40039Z'/%3e%3cpath%20class='cls-2'%20d='M200.74686,38.738a7.88852,7.88852,0,0,1-.58008,3.06933,6.98206,6.98206,0,0,1-1.60937,2.37989,7.16449,7.16449,0,0,1-2.4502,1.53027,9.02567,9.02567,0,0,1-6.15039,0,7.1738,7.1738,0,0,1-2.43945-1.53027,6.97057,6.97057,0,0,1-1.61035-2.37989,7.88852,7.88852,0,0,1-.58008-3.06933,7.80051,7.80051,0,0,1,.58008-3.07031,6.71151,6.71151,0,0,1,1.61035-2.33008,7.17851,7.17851,0,0,1,2.43945-1.47949,9.34442,9.34442,0,0,1,6.15039,0,7.1706,7.1706,0,0,1,2.4502,1.47949,6.72227,6.72227,0,0,1,1.60937,2.33008A7.80051,7.80051,0,0,1,200.74686,38.738Zm-3.66016,0a4.862,4.862,0,0,0-.2998-1.72071,4.10917,4.10917,0,0,0-.83008-1.37011,3.82649,3.82649,0,0,0-1.2793-.89942,4.06,4.06,0,0,0-1.65039-.33007,3.94,3.94,0,0,0-2.91992,1.22949,3.89736,3.89736,0,0,0-.83008,1.37011,5.31075,5.31075,0,0,0,.00977,3.49024,4.181,4.181,0,0,0,.83008,1.38965,3.76783,3.76783,0,0,0,1.27051.91015,4.23744,4.23744,0,0,0,3.27929,0,3.88608,3.88608,0,0,0,1.28028-.91015,4.09085,4.09085,0,0,0,.83984-1.38965A5.05344,5.05344,0,0,0,197.0867,38.738Z'/%3e%3cpath%20class='cls-2'%20d='M216.56913,42.86787a5.07076,5.07076,0,0,1-1.23047,1.79981A5.67781,5.67781,0,0,1,213.409,45.8376a7.7422,7.7422,0,0,1-5.03027,0,5.46752,5.46752,0,0,1-1.89942-1.16992,5.0614,5.0614,0,0,1-1.20019-1.79981,6.21675,6.21675,0,0,1-.41992-2.33008V31.71748h3.39941v8.54a3.93254,3.93254,0,0,0,.15039,1.10059,2.80891,2.80891,0,0,0,.46.92968,2.13756,2.13756,0,0,0,.82031.64942,3.26887,3.26887,0,0,0,2.46,0,2.23939,2.23939,0,0,0,.83008-.64942,2.601,2.601,0,0,0,.46-.92968,4.24267,4.24267,0,0,0,.13965-1.10059v-8.54h3.41992v8.82031A6.10438,6.10438,0,0,1,216.56913,42.86787Z'/%3e%3cpath%20class='cls-2'%20d='M232.60526,36.07783a4.34175,4.34175,0,0,1-.46,2.08985,3.78621,3.78621,0,0,1-1.24024,1.37011,5.47324,5.47324,0,0,1-1.7998.75977,9.223,9.223,0,0,1-2.12012.24023H225.285v5.33985H221.865V31.71748h5.2002a9.76129,9.76129,0,0,1,2.16992.23047,5.122,5.122,0,0,1,1.75977.73926,3.586,3.586,0,0,1,1.17968,1.34082A4.41251,4.41251,0,0,1,232.60526,36.07783Zm-3.41992.01953a1.52658,1.52658,0,0,0-.2002-.81933,1.387,1.387,0,0,0-.54-.5,2.31381,2.31381,0,0,0-.77051-.24024,6.41757,6.41757,0,0,0-.88964-.06054h-1.5v3.34082h1.44043a5.20174,5.20174,0,0,0,.91992-.08008,2.47186,2.47186,0,0,0,.79-.28028,1.50869,1.50869,0,0,0,.5498-.53027A1.58079,1.58079,0,0,0,229.18534,36.09736Z'/%3e%3c/svg%3e", Jr = {
  firstWordGroupLogo: ps
}, ms = (e, r) => [r.root], hs = ue(ye, {
  name: "Header",
  overridesResolver: ms,
  shouldForwardProp: (e) => e !== "backgroundColor" && e !== "height"
})(({ backgroundColor: e, height: r }) => ({
  width: "100%",
  backgroundColor: e,
  height: r,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "sticky",
  top: 0,
  left: 0,
  zIndex: 2,
  boxShadow: "0 2px 0 rgba(0,0,0,0.1)",
  boxSizing: "border-box"
})), gs = ue(ye)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  maxHeight: "100%",
  overflow: "hidden"
}), Mn = ({ backgroundColor: e, height: r, logo: t }) => {
  const n = !!Jr[t], o = Jr[t];
  return /* @__PURE__ */ A.jsx(hs, { backgroundColor: e, height: r, children: n ? /* @__PURE__ */ A.jsx(gs, { children: /* @__PURE__ */ A.jsx("img", { src: o, alt: t, style: { height: "100%" } }) }) : null });
};
Mn.propTypes = {
  /**
   * Background color of the header. Defaults to "#FFFFFF".
   */
  backgroundColor: b.string,
  /**
   * Height of the header. Defaults to "60px".
   */
  height: b.string,
  /**
   * Specifies the logo to be displayed in the header.
   */
  logo: b.oneOf(Object.keys(Jr)).isRequired
};
Mn.defaultProps = {
  backgroundColor: "#FFFFFF",
  height: "60px"
};
const ys = ue(Ae, {
  shouldForwardProp: (e) => ke(e) && e !== "textFont"
})(({ theme: e }) => ({
  color: e.palette.text.primary,
  fontSize: e.typography.body2.fontSize
})), bs = ue(Ae, {
  shouldForwardProp: (e) => ke(e) && e !== "textFont"
})(({ theme: e }) => ({
  ...e.typography.h5,
  fontWeight: "bold",
  textAlign: "center",
  marginBottom: "16px"
})), vs = ({ title: e, subtitle: r, textFont: t }) => /* @__PURE__ */ A.jsxs(
  ye,
  {
    sx: {
      maxWidth: "720px",
      margin: "20px auto",
      textAlign: "center",
      px: "16px"
    },
    children: [
      /* @__PURE__ */ A.jsx(bs, { textFont: t, children: e }),
      /* @__PURE__ */ A.jsx(ys, { textFont: t, children: r })
    ]
  }
);
vs.propTypes = {
  /**
   * The main title of the component.
   */
  title: b.string.isRequired,
  /**
   * The subtitle displayed below the main title.
   */
  subtitle: b.string.isRequired,
  /**
   * Font family used for text elements.
   */
  textFont: b.string
};
const xs = ({
  enabled: e,
  scriptURL: r,
  country: t,
  languageCode: n,
  cookieBannerDefault: o,
  trackingHandler: i
}) => {
  Et(() => {
    if (!e || !r) return;
    const s = "osano-script";
    return () => {
      const c = document.getElementById(s);
      c && c.remove();
    };
  }, [e, t, r, n, o]), Et(() => {
    if (!e || !r) return;
    const s = "osano-script";
    if (typeof o == "function" && o(), document.getElementById(s))
      an({ trackingHandler: i, country: t }), sn({ languageCode: n });
    else {
      const c = document.createElement("script");
      c.type = "text/javascript", c.src = r, c.id = s, c.onload = () => {
        an({ trackingHandler: i, country: t }), sn({ languageCode: n });
      }, document.head.appendChild(c);
    }
  }, [e, t, r, n]);
}, an = ({ trackingHandler: e, country: r }) => {
  const t = (i, s) => {
    i ? i.addEventListener("click", () => {
      switch (s) {
        case "genericCookieBannerPolicyLink":
          e("trackClickGenericCookieBannerPolicyLink");
          break;
        case "osanoBannerCookieClickNonUs":
          e("trackClickOsanoBannerCookieClickNonUs");
          break;
        case "genericCookieBannerClose":
          e("trackClickGenericCookieBannerClose");
          break;
        case "osanoBannerCloseNonUs":
          e("trackClickOsanoBannerCloseNonUs");
          break;
        default:
          console.warn(`Unknown action: ${s}`);
      }
    }) : console.warn(`Element for action "${s}" not found.`);
  }, n = () => {
    const i = {
      privacyLink: 'a[href*="/cookie-policy"].osano-cm-storage-policy.osano-cm-content__link.osano-cm-link',
      closeBtn: "button.osano-cm-dialog__close.osano-cm-close"
    }, s = (r == null ? void 0 : r.toLowerCase()) === "us";
    t(
      document.querySelector(i.privacyLink),
      s ? "genericCookieBannerPolicyLink" : "osanoBannerCookieClickNonUs"
    ), t(
      document.querySelector(i.closeBtn),
      s ? "genericCookieBannerClose" : "osanoBannerCloseNonUs"
    );
  };
  (() => {
    try {
      if (!(window != null && window.Osano)) {
        console.warn("Osano script is not loaded.");
        return;
      }
      (r == null ? void 0 : r.toLowerCase()) === "us" ? e("trackViewGenericCookieBannerView") : e("trackViewOsanoBannerShowNonUs"), e("trackViewOsanoViewManagePreferences"), window.Osano("onUiChanged", (i, s) => {
        s === "show" && (Ss(e, r), n(), Cs(e)), i === "drawer" && s !== "show" && e("trackClickOsanoDrawerClose");
      });
    } catch (i) {
      console.error("Error initializing Osano tracking:", i);
    }
  })();
}, Ss = (e, r) => {
  try {
    if (!(window != null && window.Osano)) {
      console.warn("Osano script is not loaded.");
      return;
    }
    const t = {
      manage: document.querySelector("button.osano-cm-button--type_manage"),
      rejectAll: document.querySelector("button.osano-cm-button--type_denyAll"),
      reject: document.querySelector("button.osano-cm-button--type_deny"),
      accept: document.querySelector("button.osano-cm-button--type_accept")
    };
    Object.keys(t).forEach((i) => {
      i !== "accept" && t[i] && (t[i].style.display = "none");
    }), (r == null ? void 0 : r.toLowerCase()) !== "us" && t.manage && (t.manage.style.display = "block");
    const n = `
      .osano-cm-dialog__buttons {
        flex-wrap: nowrap;
        min-width: 27em !important;
      }

      .osano-cm-list-item__description.osano-cm-description,
      .osano-cm-list-item__disclosure.osano-cm-disclosure {
        display: none;
      }

      .osano-cm-window__dialog.osano-cm-dialog {
        flex-direction: column;
        align-items: flex-end;
      }

      .accordion-button-class {
        background: none;
        border: none;
        padding-inline: 5px;
        font-size: 1rem;
        cursor: pointer;
        color: inherit;
      }

      .accordion-button-class:focus {
        outline: none;
      }

      .osano-cm-dialog__buttons {
        min-width: 18em !important;
      }

      .osano-cm-button {
        flex: none !important;
      }
    `, o = document.createElement("style");
    o.type = "text/css", o.appendChild(document.createTextNode(n)), document.head.appendChild(o), t.accept && t.accept.addEventListener("click", () => {
      window.clarity("consent"), e("trackClickOsanoBannerAcceptAllBtnB");
    }), t.manage && t.manage.addEventListener("click", () => {
      e("trackClickOsanoClickManagePreferences");
    });
  } catch (t) {
    console.error("Error modifying Osano buttons:", t);
  }
}, Cs = (e) => {
  try {
    if (!(window != null && window.Osano)) {
      console.warn("Osano script is not loaded.");
      return;
    }
    const r = document.querySelectorAll(
      ".osano-cm-toggle__switch.osano-cm-switch"
    )[1], t = document.querySelectorAll(
      ".osano-cm-toggle__switch.osano-cm-switch"
    )[2], n = document.querySelectorAll(
      ".osano-cm-toggle__switch.osano-cm-switch"
    )[3], o = document.querySelector(
      ".osano-cm-save.osano-cm-button"
    );
    r && r.addEventListener("click", () => {
      e("trackClickOsanoDrawerTargetAdvertising");
    }), t && t.addEventListener("click", () => {
      e("trackClickOsanoDrawerPersonalization");
    }), n && n.addEventListener("click", () => {
      e("trackClickOsanoDrawerAnalytics");
    }), o && o.addEventListener("click", () => {
      window.clarity("consent");
    }), document.querySelectorAll(
      ".osano-cm-drawer-item.osano-cm-list-item"
    ).forEach((s) => {
      const c = document.createElement("button");
      c.textContent = "＋", c.className = "accordion-button-class", c.addEventListener("click", () => {
        const d = s.querySelector(
          ".osano-cm-list-item__description.osano-cm-description"
        );
        d && (d.style.display === "block" ? (d.style.display = "none", c.textContent = "＋") : (d.style.display = "block", c.textContent = "－"));
      });
      const f = s.querySelector(
        ".osano-cm-toggle__label.osano-cm-label"
      );
      if (f) {
        const d = f.closest(
          ".osano-cm-list-item__drawer-toggle"
        );
        d && s.contains(d) ? d.appendChild(c, f) : console.warn(
          "Parent element not found or not a child of the item:",
          s
        );
      } else
        console.warn("Reference element not found in item:", s);
    });
  } catch (r) {
    console.error("Error modifying Osano buttons:", r);
  }
}, sn = ({ languageCode: e }) => {
  try {
    window != null && window.Osano ? window.Osano("locale", e) : console.warn("Osano script is not loaded.");
  } catch (r) {
    console.error("Error setting Osano language code:", r);
  }
}, Es = ({
  enabled: e,
  scriptURL: r,
  country: t,
  languageCode: n,
  cookieBannerDefault: o,
  trackingHandler: i
}) => (xs({
  enabled: e,
  scriptURL: r,
  country: t,
  languageCode: n,
  cookieBannerDefault: o,
  trackingHandler: i
}), null);
Es.propTypes = {
  /** Whether to enable the Osano script */
  enabled: b.bool.isRequired,
  /** The URL of the Osano script to load */
  scriptURL: b.string.isRequired,
  /** The user's country code (e.g., 'us') */
  country: b.string.isRequired,
  /** The language code for the banner */
  languageCode: b.string,
  /** Function to show the default cookie banner. */
  cookieBannerDefault: b.func,
  /** Function to handle tracking events. Receives (action: string, payload?: object) */
  trackingHandler: b.func
};
export {
  rs as FormButton,
  Pn as OngageCampaignsConfirmation,
  In as OngageCampaignsForm,
  ds as OngageFooter,
  Mn as OngageHeader,
  vs as OngageSuccess,
  Es as Osano,
  go as TestButton
};
